<template>
    <div>
        <Fieldset :legend="$t('searchHeader')" :toggleable="true">
            <div class="p-fluid p-mt-2 p-ml-3 p-mr-3 p-mb-2" @keyup.enter="saveData_Modal('search')">
                <div class="p-formgrid p-grid p-col">
                    <div class="p-col-12 p-lg-6 p-mt-2">
                        <div class="p-formgrid p-grid">
                            <div class="p-field p-col-10 p-lg-10">
                                <label class="p-mr-2">หน่วยงานที่รับผิดชอบ</label>
                                <Button
                                    @click="
                                        showOrganize = true;
                                        setOpenModal_OrganizeMulti = 'search';
                                    "
                                    icon="pi pi-plus"
                                    class="p-button-success"
                                    ref="TextBox_1_search"
                                    @keyup.left="moveFocus($event, 'TextBox_8_search', 'Button')"
                                    @keyup.right="moveFocus($event, 'TextBox_2_search', 'Input')"
                                    @keyup.down="moveFocus($event, 'TextBox_7_search', 'Button')"
                                />
                            </div>
                        </div>
                        <div class="p-field p-col p-mt-2" style="margin-left: -10px">
                            <DataTable
                                :value="organize_table"
                                :scrollable="true"
                                scrollHeight="500px"
                                :paginator="true"
                                :rows="3"
                                dataKey="id"
                                :rowHover="true"
                                :selection.sync="selectedOrganizeData"
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
                            >
                                <template #empty>{{ $t('TableEmpty') }}</template>
                                <Column field="organize_name" :header="$t('id_operating_name')" :sortable="true" headerStyle="width: 20rem">
                                    <template #body="dataTable">
                                        <div hidden>{{ dataTable.data.organize_id }}</div>
                                        {{ dataTable.data.organize_name }}
                                    </template>
                                </Column>
                                <Column :header="$t('controlTable')" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        <div class="p-formgrid p-grid">
                                            <div class="p-field p-col-6">
                                                <Button
                                                    @click="
                                                        // displayConfirmation = true;
                                                        deleteAt = 'organize';
                                                        organizeDelete = dataTable.data;
                                                        alertDisplay(organizeDelete, deleteAt);
                                                    "
                                                    icon="pi pi-trash"
                                                    :label="$t('deleteBtn')"
                                                    class="p-button-rounded p-button-danger"
                                                />
                                            </div>
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                    </div>

                    <div class="p-col p-mt-3 p-ml-3">
                        <div class="p-grid p-col">
                            <div class="p-field p-col-12 p-lg-6 p-mt-2">
                                <label for="csb_itemName">รายการ</label>
                                <InputText
                                    id="csb_itemName"
                                    type="text"
                                    v-model="csb_itemName"
                                    ref="TextBox_2_search"
                                    @keyup.left="moveFocus($event, 'TextBox_1_search', 'Button')"
                                    @keyup.right="moveFocus($event, 'TextBox_3_search', 'Input')"
                                    @keyup.up="moveFocus($event, 'TextBox_1_search', 'Button')"
                                    @keyup.down="moveFocus($event, 'TextBox_3_search', 'Input')"
                                />
                            </div>
                            <div class="p-field p-col-12 p-lg-6 p-mt-2">
                                <label for="csb_sourceType_Selector">ประเภทที่มา</label>

                                <Dropdown
                                    v-model="csb_sourceType_Selector"
                                    optionLabel="name"
                                    :options="csb_sourceType_Option"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                    :filter="true"
                                    :showClear="true"
                                >
                                    <template #value="csb_sourceType_Option">
                                        <div v-if="csb_sourceType_Option.value">
                                            <div>{{ csb_sourceType_Option.value }}</div>
                                        </div>
                                        <span v-else>
                                            {{ csb_sourceType_Option.placeholder }}
                                        </span>
                                    </template>
                                    <template #option="csb_sourceType_Option">
                                        <div>{{ csb_sourceType_Option.option }}</div>
                                    </template>
                                </Dropdown>
                            </div>
                        </div>

                        <div class="p-grid p-col">
                            <div class="p-field p-col-12 p-lg-6 p-mt-3">
                                <label for="csb_source_location">แหล่งที่มา</label>
                                <InputText
                                    id="csb_source_location"
                                    type="text"
                                    v-model="csb_source_location"
                                    ref="TextBox_3_search"
                                    @keyup.left="moveFocus($event, 'TextBox_2_search', 'Input')"
                                    @keyup.right="moveFocus($event, 'TextBox_4_search', 'Button')"
                                    @keyup.up="moveFocus($event, 'TextBox_2_search', 'Input')"
                                    @keyup.down="moveFocus($event, 'TextBox_6_search', 'Input')"
                                />
                            </div>
                            <div class="p-field p-col-12 p-lg-6 p-mt-3">
                                <div style="display: flex">
                                    <div style="width: calc(100% - 80px); margin-right: 7px">
                                        <label for="csb_storage_location">สถานที่จัดเก็บ</label>
                                        <InputText
                                            style="margin-top: 7px"
                                            id="csb_storage_location"
                                            type="text"
                                            v-model="csb_storage_location.name"
                                            disabled
                                        />
                                    </div>
                                    <div style="width: 73px; margin-top: -3px">
                                        <div>
                                            <Button
                                                @click="
                                                    showOrganize_Form = true;
                                                    setOpenModal_Organize = 'search';
                                                "
                                                icon="pi pi-ellipsis-h"
                                                class="p-button-secondary p-mt-5 p-mr-2"
                                                ref="TextBox_4_search"
                                                @keyup.left="moveFocus($event, 'TextBox_3_search', 'Input')"
                                                @keyup.right="moveFocus($event, 'TextBox_5_search', 'Button')"
                                                @keyup.up="moveFocus($event, 'TextBox_2_search', 'Input')"
                                                @keyup.down="moveFocus($event, 'TextBox_6_search', 'Input')"
                                            />
                                            <Button
                                                @click="csb_storage_location = {}"
                                                icon="pi pi-times"
                                                class="p-button-danger p-mt-5"
                                                ref="TextBox_5_search"
                                                @keyup.left="moveFocus($event, 'TextBox_4_search', 'Button')"
                                                @keyup.right="moveFocus($event, 'TextBox_6_search', 'Input')"
                                                @keyup.up="moveFocus($event, 'TextBox_2_search', 'Input')"
                                                @keyup.down="moveFocus($event, 'TextBox_6_search', 'Input')"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="p-grid p-col p-mt-1">
                                <div class="p-field p-col-12 p-lg-4 p-mt-2">
                                    <label for="csb_receivedDate">วันที่ได้รับ</label>
                                    <Calendar
                                        dateFormat="dd/mm/yy"
                                        :showButtonBar="true"
                                        :maxDate="typeof csb_expirationDate === 'object' ? csb_expirationDate : null"
                                        :monthNavigator="true"
                                        :yearNavigator="true"
                                        yearRange="2000:2050"
                                        :locale="th"
                                        v-model="csb_receivedDate"
                                    ></Calendar>
                                </div>
                                <div class="p-field p-col-12 p-lg-4 p-mt-2">
                                    <label for="csb_expirationDate">วันหมดอายุ</label>
                                    <Calendar
                                        dateFormat="dd/mm/yy"
                                        :showButtonBar="true"
                                        :minDate="typeof csb_receivedDate === 'object' ? csb_receivedDate : null"
                                        :monthNavigator="true"
                                        :yearNavigator="true"
                                        yearRange="2000:2050"
                                        :locale="th"
                                        v-model="csb_expirationDate"
                                    ></Calendar>
                                </div>
                                <div class="p-field p-col-12 p-lg-4 p-mt-2">
                                    <label for="csb_consumables_code">เลขทะเบียนทรัพย์สิน</label>
                                    <InputText
                                        id="csb_consumables_code"
                                        type="text"
                                        v-model="csb_consumables_code"
                                        ref="TextBox_6_search"
                                        @keyup.left="moveFocus($event, 'TextBox_5_search', 'Button')"
                                        @keyup.right="moveFocus($event, 'TextBox_7_search', 'Button')"
                                        @keyup.up="moveFocus($event, 'TextBox_4_search', 'Button')"
                                        @keyup.down="moveFocus($event, 'TextBox_7_search', 'Button')"
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="p-field p-col">
                            <div class="p-formgrid p-grid">
                                <div class="p-field p-col">
                                    <div class="p-formgrid p-grid p-jc-end p-mt-5">
                                        <!-- Doe โหลด โทรศัพท์ -->
                                        <Button
                                            v-if="window.width <= 430"
                                            @click="MobileClearSearchField()"
                                            :label="$t('clearBtn')"
                                            class="p-button-clear p-ml-3 p-mr-3"
                                            ref="TextBox_7_search"
                                            @keyup.left="moveFocus($event, 'TextBox_6_search', 'Input')"
                                            @keyup.right="moveFocus($event, 'TextBox_8_search', 'Button')"
                                            @keyup.up="moveFocus($event, 'TextBox_6_search', 'Input')"
                                        />
                                        <Button
                                            v-else
                                            @click="clearSearchField()"
                                            :label="$t('clearBtn')"
                                            class="p-button-clear p-ml-3 p-mr-3"
                                            ref="TextBox_7_search"
                                            @keyup.left="moveFocus($event, 'TextBox_6_search', 'Input')"
                                            @keyup.right="moveFocus($event, 'TextBox_8_search', 'Button')"
                                            @keyup.up="moveFocus($event, 'TextBox_6_search', 'Input')"
                                        />
                                        <!-- Doe โหลด โทรศัพท์ -->
                                        <Button
                                            @click="searchConsumables()"
                                            :label="$t('searchBtn')"
                                            class="p-button-info"
                                            ref="TextBox_8_search"
                                            @keyup.left="moveFocus($event, 'TextBox_7_search', 'Button')"
                                            @keyup.right="moveFocus($event, 'TextBox_1_search', 'Input')"
                                            @keyup.up="moveFocus($event, 'TextBox_6_search', 'Input')"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="p-formgrid p-grid p-col p-mt-1">
                    <text-footer :data="Data_text_Footer" :checkShow="text_Footer" :countItem="consumables_Table.length.toLocaleString('en-US')" />
                </div>
            </div>
        </Fieldset>

        <Dialog :modal="true" :header="$t('OrganizeModalHeader')" :visible.sync="showOrganize" :style="{ width: '80%', overflow: 'auto' }">
            <organize-table
                @selectOrganization="selectedOrganize_passValue"
                :parentmessage="parentmessage_organize"
                :checkForm="checkSelectedOrganize(setOpenModal_OrganizeMulti)"
            ></organize-table>
        </Dialog>

        <Dialog :modal="true" :header="$t('OrganizeModalHeader')" :visible.sync="showOrganize_Form" :style="{ width: '80%', overflow: 'auto' }">
            <organize-form
                @selectOrganization="selectedOrganize_passValue_Form"
                :checkForm="checkSelectedOrganize(setOpenModal_Organize)"
            ></organize-form>
        </Dialog>

        <div class="card p-fluid p-mt-2">
            <!-- Doe : เพิ่ม ลำดับ 1/4   sortField="index" :sortOrder="1" -->
            <DataTable
                :value="columns_disabled ? consumables_Table : []"
                :paginator="true"
                :rows="10"
                scrollHeight="500px"
                dataKey="consumables_id"
                :sortOrder="1"
                sortField="index"
                ref="dt"
                :exportFilename="`ข้อมูลเครื่องอุปโภค บริโภค-${date}`"
                :selection.sync="selectedConsumables"
                :rowHover="true"
                :filters="filters"
                :loading="loading"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[10, 20, 50]"
                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
            >
                <!-- Doe : เพิ่ม ลำดับ 1/4 จบ  sortField="index" :sortOrder="1" -->
                <template #header>
                    <div class="p-grid">
                        <div class="table-header p-col-12 p-lg-1" style="padding: 7px" id="Create" v-if="checkAdd_data != 'false'">
                            <Button @click="consumables_TableModal = true" :label="$t('addBtn')" class="p-button-success" />
                        </div>

                        <!-- Doe : PDF 1/3 -->
                        <div class="table-header" style="padding: 7px" id="EX">
                            <Button @click="exportCSV('dt')" :label="$t('exportBtn')" style="background-color: green" />
                        </div>
                        <div class="table-header" style="padding: 7px" id="PDF">
                            <SplitButton
                                label="ส่งออก PDF"
                                :model="items"
                                class="p-button-raised p-button-danger"
                                style="background-color: #f33737"
                            ></SplitButton>
                        </div>
                        <!-- Doe : PDF 1/3 จบ -->

                        <!-- Doe PDF เลือกได้  1/5   -->
                        <div class="table-header" id="TABLE_EDIT" style="padding: 7px">
                            <Button
                                @click="EditPDF()"
                                icon="pi pi-cog"
                                :label="'ตั้งค่า'"
                                style="background-color: #0288d1; border: 1px solid #0288d1"
                            />
                        </div>

                        <div class="table-header" id="TABLE_EDIT" style="padding: 7px" v-if="selectedConsumables && selectedConsumables.length > 0">
                            <Button
                                @click="updateDates()"
                                icon="pi pi-cog"
                                :label="'ปรับปรุงข้อมูล'"
                                style="background-color: #fab12f; border: 1px solid #fab12f"
                            />
                        </div>

                        <!-- Doe PDF เลือกได้  1/5 จบ  -->

                        <div class="table-header p-col-12 p-lg-3" id="Search" style="margin-left: auto">
                            <!-- <span class="p-input-icon-left">
                  <i class="pi pi-search" /><InputText
                    v-model="filters['global']"
                    :placeholder="$t('searchHeader')"
                  />
                </span> -->

                            <!-- Doe ค้นหา  1/5 -->

                            <span class="p-input-icon-left" v-if="columns_disabled">
                                <i class="pi pi-search" />
                                <InputText v-model="filter" @input="search()" :placeholder="$t('searchHeader')" />
                            </span>
                            <span class="p-input-icon-left" v-else>
                                <i class="pi pi-search" />
                                <InputText disabled v-model="filter" @input="search()" :placeholder="$t('searchHeader')" />
                            </span>

                            <!-- Doe ค้นหา  1/5 จบ-->
                        </div>
                    </div>
                </template>

                <Column :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')">
                    <template #header>
                        <div v-if="columns_disabled">
                            <input
                                style="width: 20px; height: 20px"
                                type="checkbox"
                                :checked="selectedConsumables.length === consumables_Table.length"
                                @change="onSelectAll($event.target.checked)"
                            />
                        </div>
                    </template>
                    <template #body="slotProps">
                        <div class="table_row" v-if="columns_disabled" style="text-align: center">
                            <input
                                style="width: 20px; height: 20px"
                                type="checkbox"
                                :checked="selectedConsumables.some((item) => item.consumables_id === slotProps.data.consumables_id)"
                                @change="onSelectRow(slotProps.data, $event.target.checked)"
                            />
                        </div>
                    </template>
                </Column>

                <template #empty>{{ $t('TableEmpty') }}</template>
                <!--Doe : เพิ่มลำดับ 2/4-->
                <div v-if="columns_index == true">
                    <Column field="index" :header="'ลำดับ'" :sortable="true" :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div v-if="columns_index == true">
                                <div class="table_row">
                                    {{ dataTable.data.index }}
                                </div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>
                <!--Doe : เพิ่มลำดับ 2/4 จบ-->

                <div v-if="columns_img == true">
                    <Column field="" :header="'รูปภาพ'" :headerStyle="tableColSticky('20rem', '', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div v-if="columns_img == true">
                                <div v-if="dataTable.data.image !== '' && dataTable.data.image !== null && columns_img == true">
                                    <img
                                        :src="`${dataTable.data.image}`"
                                        @click="showImage(dataTable.data.image)"
                                        alt=""
                                        style="height: 112px; max-width: 240px"
                                    />
                                </div>

                                <div v-else>-</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"> </Column>
                </div>

                <div v-if="columns_date_received == true">
                    <Column
                        field="date_received"
                        :header="'วันที่ได้รับ'"
                        :sortable="true"
                        :headerStyle="tableColSticky('250px', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_date_received == true">
                                {{ dataTable.data.date_received }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_item_name == true">
                    <Column field="item_name" :header="'รายการ'" :sortable="true" :headerStyle="tableColSticky('250px', '', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div v-if="columns_item_name == true">
                                {{ dataTable.data.item_name }}
                            </div>
                        </template>
                    </Column>
                </div>

                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_quantity == true">
                    <!-- อันใหม่ของป๊อปอาย -->
                    <Column field="quantity" :header="'จำนวน'" :sortable="true" :headerStyle="tableColSticky('150px', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_quantity == true">
                                {{ dataTable.data.quantity }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>
                <!-- เพิ่ม coloums จำนวน จบ -->

                <div v-if="columns_total_expense == true">
                    <Column
                        field="total_expense"
                        :header="'จ่ายออก'"
                        :sortable="true"
                        :headerStyle="tableColSticky('150px', 'center', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_total_expense == true">
                                {{ dataTable.data.total_expense }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_remaining_balance == true">
                    <Column
                        field="remaining_balance"
                        :header="'ยอดคงเหลือ'"
                        :sortable="true"
                        :headerStyle="tableColSticky('150px', 'center', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_remaining_balance == true">
                                {{ dataTable.data.remaining_balance }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_unit == true">
                    <!-- เพิ่ม coloums หมายเลขครุภัณฑ์ -->
                    <Column field="unit" :header="'หน่วย'" :sortable="true" :headerStyle="tableColSticky('240px', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_unit == true">
                                {{ dataTable.data.unit }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>
                <!-- เพิ่ม coloums หมายเลขครุภัณฑ์ จบ -->

                <div v-if="columns_date_expiration == true">
                    <Column
                        field="date_expiration"
                        :header="'วันหมดอายุ'"
                        :sortable="true"
                        :headerStyle="tableColSticky('250px', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_date_expiration == true">
                                {{ dataTable.data.date_expiration }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_storage_location == true">
                    <Column
                        field="storage_location"
                        :header="'สถานที่จัดเก็บ'"
                        :sortable="true"
                        :headerStyle="tableColSticky('200px', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_storage_location == true">
                                {{ dataTable.data.storage_location }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_lat == true">
                    <Column field="organize_lat" :header="'ละติจูด'" :sortable="true" :headerStyle="tableColSticky('200px', '', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div v-if="columns_lat == true">
                                {{ parseFloat(dataTable.data.organize_lat).toFixed(6) }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_lon == true">
                    <Column field="organize_lon" :header="'ลองจิจูด'" :sortable="true" :headerStyle="tableColSticky('200px', '', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div v-if="columns_lon == true">
                                {{ parseFloat(dataTable.data.organize_lon).toFixed(6) }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_source_type == true">
                    <Column field="source_type" :header="'ประเภทที่มา'" :sortable="true" :headerStyle="tableColSticky('200px', '', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_source_type == true">
                                {{ dataTable.data.source_type }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_source_location == true">
                    <Column
                        field="source_location"
                        :header="'แหล่งที่มา'"
                        :sortable="true"
                        :headerStyle="tableColSticky('200px', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_source_location == true">
                                {{ dataTable.data.source_location }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_consumables_code == true">
                    <Column
                        field="consumables_code"
                        :header="'เลขทะเบียนทรัพย์สิน'"
                        :sortable="true"
                        :headerStyle="tableColSticky('200px', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_consumables_code == true">
                                {{ dataTable.data.consumables_code }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_organize_name == true">
                    <Column field="organize_name" :header="'หน่วยงาน'" :sortable="true" :headerStyle="tableColSticky('230px', '', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div v-if="columns_organize_name == true">
                                {{ dataTable.data.organize_name }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <!-- <div v-if="columns_source_location == true"> 
            <Column
              field="text_detail"
              :header="'บัญชีจ่ายสิ่งของบริจาค'"       
              :sortable="true"
              :headerStyle="tableColSticky('20rem','','sticky','top')"
            >
            
              <template #body="dataTable">
                <span v-html="dataTable.data.text_detailHTML"></span>
              </template>
            </Column>
          </div>
          <div v-else>
                <Column headerStyle="width: 0"></Column>
          </div> -->

                <div v-if="columns_date_create_consumables == true">
                    <Column
                        field="date_create_consumables"
                        :header="'วันที่สร้างข้อมูล'"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_date_create_consumables == true">
                                {{ dataTable.data.date_create_consumables }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_date_update_consumables == true">
                    <Column
                        field="date_update_consumables"
                        :header="'วันที่ปรับปรุงข้อมูลล่าสุด'"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_date_update_consumables == true">
                                {{ dataTable.data.date_update_consumables }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_editor == true">
                    <Column field="user_fullname" :header="'ผู้แก้ไข'" :sortable="true" :headerStyle="tableColSticky('200px', '', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div v-if="columns_editor == true">
                                {{ dataTable.data.user_fullname }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div
                    v-if="
                        columns_index ||
                        columns_img ||
                        columns_date_received ||
                        columns_item_name ||
                        columns_quantity ||
                        columns_total_expense ||
                        columns_remaining_balance ||
                        columns_unit ||
                        columns_date_expiration ||
                        columns_storage_location ||
                        columns_lat ||
                        columns_lon ||
                        columns_source_type ||
                        columns_source_location ||
                        columns_consumables_code ||
                        columns_organize_name ||
                        columns_date_create_consumables ||
                        columns_date_update_consumables ||
                        columns_editor
                    "
                >
                    <Column :header="$t('controlTable')" :headerStyle="table_headerStyle" :bodyStyle="table_bodyStyle">
                        <template #body="dataTable">
                            <div
                                class="p-formgrid col_manege"
                                style="display: flex; justify-content: center"
                                v-if="checkNotAdminPermission(dataTable.data.user_organize)"
                            >
                                <div :class="table_BOXmanege" v-if="checkEdit_data != 'false'">
                                    <Button
                                        @click="
                                            consumables_TableModal = true;
                                            editData(dataTable.data.consumables_id);
                                            temp = dataTable.data.consumables_id;
                                        "
                                        icon="pi pi-pencil"
                                        :label="table_editBTN"
                                        class="p-button-rounded p-button-warning"
                                    />
                                </div>
                                <div :class="table_BOXmanege" v-if="checkDelete_data != 'false'">
                                    <Button
                                        @click="
                                            // displayConfirmation = true;
                                            temp = dataTable.data.consumables_id;
                                            deleteAt = '';
                                            alertDisplay(temp, deleteAt);
                                        "
                                        icon="pi pi-trash"
                                        :label="table_deleteBTN"
                                        class="p-button-rounded p-button-danger"
                                    />
                                </div>
                            </div>
                            <div v-else style="padding: 7px 0px">
                                <div>
                                    {{ 'ไม่มีสิทธิ์จัดการข้อมูลนี้' }}
                                </div>
                                <div :class="table_BOXmanege">
                                    <Button
                                        @click="
                                            setExport_DI(
                                                true,
                                                JSON.parse(dataTable.data.detail_expense),
                                                dataTable.data.item_name,
                                                dataTable.data.quantity
                                            )
                                        "
                                        icon="pi pi-download"
                                        :label="table_loadBTN"
                                        style="
                                            background-color: #2752df;
                                            border: 1px solid #2752df;
                                            max-width: 100px;
                                            border-radius: 2rem;
                                            margin-top: 7px;
                                        "
                                    />
                                </div>
                            </div>

                            <div
                                v-if="checkNotAdminPermission(dataTable.data.user_organize)"
                                :class="table_BOXmanege"
                                style="padding: 0px 0px 21px 0px; margin-top: -14px"
                            >
                                <Button
                                    @click="
                                        setExport_DI(
                                            true,
                                            JSON.parse(dataTable.data.detail_expense),
                                            dataTable.data.item_name,
                                            dataTable.data.quantity,
                                            dataTable.data.detail_expense
                                        )
                                    "
                                    icon="pi pi-download"
                                    :label="table_loadBTN"
                                    style="background-color: #2752df; border: 1px solid #2752df; max-width: 100px; border-radius: 2rem"
                                />
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column headerStyle="width: 0"></Column>
                </div>
            </DataTable>
        </div>
        <!-- v-if="loadingCreate" -->
        <!-- Manage data -->
        <Dialog
            :modal="true"
            :visible.sync="consumables_TableModal"
            :style="{ width: '85%' }"
            :contentStyle="{ 'overflow-y': 'auto' }"
            :closable="loadingCreate ? false : true"
            :header="header"
        >
            <div class="confirmation-content" @keyup.enter="saveData_Modal('Modal_Main')">
                <!-- โหลดเพิ่มแก้ไข 1/8-->
                <div class="From_Loading" v-if="loadingCreate">
                    <ProgressSpinner style="width: 120px; height: 120px; color: red" strokeWidth="5" animationDuration="1s" />
                    <div class="waveTextAnimated">
                        <span>กำ</span>
                        <span>ลัง</span>
                        <span>บัน</span>
                        <span>ทึก</span>
                        <span>ข้อ</span>
                        <span>มูล</span>
                        <!-- กำลังบันทึกข้อมูล -->
                    </div>
                </div>
                <!-- โหลดเพิ่มแก้ไข 1/8 จบ-->
                <label>{{ $t('iev_modal_subtitle') }}</label>
                <div class="p-fluid p-mt-5">
                    <div class="p-grid">
                        <!-- ส่วนชื่อเครื่องมือ -->

                        <div class="p-field p-col-12 p-lg-3">
                            <label for="csbForm_itemName">รายการ <span class="required-input">*</span></label>
                            <InputText
                                id="csbForm_itemName"
                                type="text"
                                v-model="csbForm_itemName"
                                autofocus
                                required="true"
                                :class="{
                                    'p-invalid': error_csbForm_itemName && !csbForm_itemName
                                }"
                                ref="TextBox_1"
                                @keyup.left="moveFocus($event, 'TextBox_16', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_2', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_4', 'Input')"
                            />
                            <small class="p-invalid" v-if="error_csbForm_itemName && !csbForm_itemName">กรุณาระบุชื่อรายการ</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-3">
                            <label for="csbForm_consumables_code">เลขทะเบียนทรัพย์สิน <span class="required-input"> </span></label>
                            <InputText
                                id="csbForm_consumables_code"
                                type="text"
                                v-model="csbForm_consumables_code"
                                required="true"
                                ref="TextBox_2"
                                @keyup.left="moveFocus($event, 'TextBox_1', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_3', 'InputNumber')"
                                @keyup.down="moveFocus($event, 'TextBox_5', 'Button')"
                            />
                        </div>

                        <!-- ใหม่ -->

                        <div class="p-field p-col-12 p-lg-2">
                            <label for="csbForm_quantity">จำนวน <span class="required-input">*</span></label>
                            <!-- <InputText
                    id="csbForm_quantity"
                    type="text"
                    v-model="csbForm_quantity"  
                    @input="acceptNumber()"   
                     min="0.00"
                    :class="{
                        'p-invalid':
                        error_csbForm_quantity && !csbForm_quantity,
                      }"
                  /> -->
                            <InputNumber
                                id="csbForm_quantity"
                                :min="0"
                                v-model="csbForm_quantity"
                                :class="`
                      ${error_csbForm_quantity && !csbForm_quantity ? 'p-invalid ' : ''} 
                      ${error_Over_quantity && csbForm_quantity > 100000000 ? 'p-invalid ' : ''}
                      ${parseInt(csbForm_quantity) < parseInt(csbForm_total_expense) ? 'p-invalid ' : ''}
                      `"
                                ref="TextBox_3"
                                @keyup.left="moveFocus($event, 'TextBox_2', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_4', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_7', 'Button')"
                            />
                            <small class="p-invalid" v-if="error_csbForm_quantity && !csbForm_quantity">กรุณาระบุจำนวน</small>
                            <small class="p-invalid" v-if="error_Over_quantity && csbForm_quantity > 100000000"
                                >กรุณาระบุจำนวนน้อยกว่า 100,000,000</small
                            >
                            <small class="p-invalid" v-else-if="parseInt(csbForm_quantity) < parseInt(csbForm_total_expense)"
                                >กรุณาระบุจำนวน มากกว่า จ่ายออก</small
                            >
                        </div>

                        <div class="p-field p-col-12 p-lg-2">
                            <label for="csbForm_total_expense">จ่ายออก <span class="required-input"> </span></label>
                            <!-- <InputText
                  id="csbForm_total_expense"
                  v-model="csbForm_total_expense"
                  type="text"
                  autofocus
                  disabled
                /> -->
                            <InputNumber id="csbForm_total_expense" v-model="csbForm_total_expense" type="text" autofocus disabled />
                        </div>

                        <div class="p-field p-col-12 p-lg-2">
                            <label for="csbForm_remaining_balance">ยอดคงเหลือ <span class="required-input"> </span></label>
                            <!-- <InputText
                  id="csbForm_remaining_balance"
                  v-model="csbForm_remaining_balance"
                  type="text"
                  autofocus
                  disabled
                /> -->
                            <InputNumber id="csbForm_remaining_balance" v-model="csbForm_remaining_balance" type="text" autofocus disabled />
                        </div>

                        <div class="p-field p-col-12 p-lg-3">
                            <label for="Maintenance_unit">หน่วยนับ <span class="required-input">*</span></label>
                            <Dropdown
                                v-model="Maintenance_unit"
                                :options="unitNameOptions"
                                optionLabel="system_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                                :class="{
                                    'p-invalid': error_csbForm_Maintenance_unit && !Maintenance_unit
                                }"
                            >
                                <template #value="unitNameOptions">
                                    <div v-if="unitNameOptions.value" class="DD_data">
                                        <div>{{ unitNameOptions.value.system_name }}</div>
                                    </div>
                                    <div class="DD_data" v-else>
                                        {{ unitNameOptions.placeholder }}
                                    </div>
                                </template>
                                <template #option="unitNameOptions">
                                    <div>{{ unitNameOptions.option.system_name }}</div>
                                </template>
                            </Dropdown>

                            <small class="p-invalid" v-if="error_csbForm_Maintenance_unit && !Maintenance_unit">กรุณาระบุหน่วยนับ</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-3">
                            <label for="csbForm_date_received">วันที่ได้รับ <span class="required-input">*</span></label>
                            <Calendar
                                :class="`
                      ${check_date_received && donatedItems_data.length !== 0 ? 'p-invalid ' : ''} 
                      ${error_csbForm_date_received && checkCsbForm_date_received(csbForm_date_received) ? 'p-invalid ' : ''}`"
                                dateFormat="dd/mm/yy"
                                :maxDate="setTimeMaxMin(csbForm_date_expiration)"
                                :manualInput="true"
                                :showButtonBar="true"
                                :monthNavigator="true"
                                :yearNavigator="true"
                                :yearRange="`2000:${setYearRange(date_yearRange, 1, 'plus')}`"
                                :locale="th"
                                v-model="csbForm_date_received"
                            ></Calendar>
                            <small class="p-invalid" v-if="error_csbForm_date_received && checkCsbForm_date_received(csbForm_date_received)"
                                >กรุณาระบุ วันที่ได้รับ
                            </small>
                            <small class="p-invalid" v-if="check_date_received && donatedItems_data.length !== 0"
                                >เนื่องจากมีการ จ่ายสิ่งของในวันที่ {{ DataError_date_received[DataError_date_received.length - 1] }}
                            </small>
                        </div>
                        <div class="p-field p-col-12 p-lg-3">
                            <label for="csbForm_date_expiration">วันหมดอายุ <span class="required-input"></span></label>
                            <Calendar
                                dateFormat="dd/mm/yy"
                                :minDate="setTimeMaxMin(csbForm_date_received)"
                                :showButtonBar="true"
                                :manualInput="true"
                                :monthNavigator="true"
                                :yearNavigator="true"
                                :yearRange="`2000:2050`"
                                :locale="th"
                                id="iev_historyOfMaintenance_enddate"
                                v-model="csbForm_date_expiration"
                            ></Calendar>
                        </div>

                        <div class="p-field p-col-12 p-lg-3">
                            <label for="csbForm_source_type"
                                >ประเภทที่มา
                                <span class="required-input">*</span>
                            </label>
                            <Dropdown
                                v-model="csbForm_source_type"
                                optionLabel="name"
                                :options="csb_sourceType_Option"
                                :placeholder="$t('placeholderSelectBox')"
                                :clearFilterDropdown="dropdownClearFilerValue"
                                :filter="true"
                                :showClear="true"
                                :class="{
                                    'p-invalid': error_csbForm_source_type && !csbForm_source_type
                                }"
                            >
                                <template #value="csb_sourceType_Option">
                                    <div v-if="csb_sourceType_Option.value">
                                        <div>{{ csb_sourceType_Option.value }}</div>
                                    </div>
                                    <span v-else>
                                        {{ csb_sourceType_Option.placeholder }}
                                    </span>
                                </template>
                                <template #option="csb_sourceType_Option">
                                    <div>{{ csb_sourceType_Option.option }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_csbForm_source_type && !csbForm_source_type">กรุณาระบุประเภทที่มา</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-3">
                            <label for="csbForm_source_location">แหล่งที่มา <span class="required-input">* </span></label>
                            <InputText
                                id="csbForm_source_location"
                                type="text"
                                v-model="csbForm_source_location"
                                autofocus
                                required="true"
                                :class="{
                                    'p-invalid': error_csbForm_source_location && !csbForm_source_location
                                }"
                                ref="TextBox_4"
                                @keyup.left="moveFocus($event, 'TextBox_3', 'InputNumber')"
                                @keyup.right="moveFocus($event, 'TextBox_5', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_1', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_9', 'Button')"
                            />
                            <small class="p-invalid" v-if="error_csbForm_source_location && !csbForm_source_location">กรุณาระบุแหล่งที่มา</small>
                        </div>
                        <!-- จบใหม่ -->

                        <!-- ส่วนหน่วยงานที่รับผิดชอบ -->
                        <!-- <div class="p-formgrid p-grid p-mt-2" > -->
                        <div class="p-field p-col-8 p-lg-4">
                            <label for="iev_organize">หน่วยงานที่รับผิดชอบ <span class="required-input">*</span></label>
                            <InputText
                                id="iev_organize"
                                type="text"
                                v-model="iev_organize.name"
                                disabled
                                :class="{
                                    'p-invalid': error_iev_organize && !iev_organize.name
                                }"
                            />
                            <small class="p-invalid" v-if="error_iev_organize && !iev_organize.name">{{ $t('iev_organize_validate') }}</small>
                        </div>
                        <div class="p-field" style="padding-top: 7px">
                            <div>
                                <Button
                                    @click="
                                        showOrganize_Form = true;
                                        setOpenModal_Organize = '';
                                    "
                                    icon="pi pi-ellipsis-h"
                                    class="p-button-secondary p-mt-5 p-mr-2"
                                    ref="TextBox_5"
                                    @keyup.left="moveFocus($event, 'TextBox_4', 'Input')"
                                    @keyup.right="moveFocus($event, 'TextBox_6', 'Button')"
                                    @keyup.up="moveFocus($event, 'TextBox_2', 'Input')"
                                    @keyup.down="moveFocus($event, 'TextBox_9', 'Button')"
                                />
                                <Button
                                    @click="iev_organize = {}"
                                    icon="pi pi-times"
                                    class="p-button-danger p-mt-5"
                                    ref="TextBox_6"
                                    @keyup.left="moveFocus($event, 'TextBox_5', 'Button')"
                                    @keyup.right="moveFocus($event, 'TextBox_7', 'Button')"
                                    @keyup.up="moveFocus($event, 'TextBox_2', 'Input')"
                                    @keyup.down="moveFocus($event, 'TextBox_10', 'Button')"
                                />
                            </div>
                        </div>
                        <!-- </div> -->
                        <!-- / -->

                        <!-- ส่วนรูปภาพ -->
                        <div class="p-col-12 p-lg-4 p-mt-5">
                            <span hidden>{{ url }}</span>
                            <div class="p-grid">
                                <div class="p-col-8 p-lg-8">
                                    <Button
                                        @click="onFileChange"
                                        class="p-button-success"
                                        icon="pi pi-plus"
                                        label="เลือกไฟล์ภาพ"
                                        ref="TextBox_7"
                                        @keyup.left="moveFocus($event, 'TextBox_6', 'Button')"
                                        @keyup.right="moveFocus($event, 'TextBox_8', 'Button')"
                                        @keyup.up="moveFocus($event, 'TextBox_3', 'InputNumber')"
                                        @keyup.down="moveFocus($event, 'TextBox_10', 'Button')"
                                    >
                                    </Button>

                                    <input
                                        ref="file"
                                        style="visibility: hidden; display: none; text-overflow: ellipsis"
                                        type="file"
                                        id="csb_uploadImageFile"
                                        @change="onFileChange"
                                        class="inputzone"
                                        accept="image/*"
                                    />
                                    <!-- <button style="  @click="onFileChange">Choose</button> -->
                                </div>
                                <div class="p-col-4 p-lg-4">
                                    <Button
                                        @click="clearImage()"
                                        icon="pi pi-times"
                                        class="p-button-danger"
                                        style="width: auto"
                                        :label="$t('clearImage')"
                                        ref="TextBox_8"
                                        @keyup.left="moveFocus($event, 'TextBox_7', 'Button')"
                                        @keyup.right="moveFocus($event, 'TextBox_9', 'Button')"
                                        @keyup.up="moveFocus($event, 'TextBox_3', 'InputNumber')"
                                        @keyup.down="moveFocus($event, 'TextBox_10', 'Button')"
                                    />
                                </div>
                            </div>
                            <!-- <div id="preview"> {{ pic }} </div> -->
                            <div id="preview">
                                <img v-if="url" :src="url" />
                            </div>
                            <div id="csb_image" ref="csb_image" hidden></div>
                        </div>
                    </div>
                    <!-- / -->

                    <!-- map -->
                    <!-- Doe เพิ่มหมุด map V.2 1/9  @input="inputMap_PAT_latlon" -->
                    <div class="p-formgrid p-grid p-mt-3">
                        <div class="p-grid p-col-12">
                            <div class="p-col-12 p-lg-6">
                                <div style="display: flex">
                                    <div style="width: calc(100% - 70px); margin-right: 7px">
                                        <label for="iev_equipment_name">
                                            สถานที่จัดเก็บ
                                            <span class="required-input"> *</span>
                                        </label>
                                        <InputText
                                            style="margin-top: 7px"
                                            id="csbForm_storage_location"
                                            type="text"
                                            v-model="csbForm_storage_location.name"
                                            disabled
                                            :class="{
                                                'p-invalid': error_csbForm_storage_location && !csbForm_storage_location.name
                                            }"
                                        />
                                        <small class="p-invalid" v-if="error_csbForm_storage_location && !csbForm_storage_location.name"
                                            >กรุณาระบุ สถานที่จัดเก็บ</small
                                        >
                                    </div>
                                    <div style="width: 90px">
                                        <div>
                                            <Button
                                                @click="
                                                    showOrganize_Form = true;
                                                    setOpenModal_Organize = 'storage';
                                                "
                                                icon="pi pi-ellipsis-h"
                                                class="p-button-secondary p-mt-5 p-mr-2"
                                                ref="TextBox_9"
                                                @keyup.left="moveFocus($event, 'TextBox_8', 'Button')"
                                                @keyup.right="moveFocus($event, 'TextBox_10', 'Button')"
                                                @keyup.up="moveFocus($event, 'TextBox_4', 'Input')"
                                                @keyup.down="moveFocus($event, 'TextBox_11', 'Input')"
                                            />
                                            <Button
                                                @click="csbForm_storage_location = {}"
                                                icon="pi pi-times"
                                                class="p-button-danger p-mt-5"
                                                ref="TextBox_10"
                                                @keyup.left="moveFocus($event, 'TextBox_9', 'Button')"
                                                @keyup.right="moveFocus($event, 'TextBox_11', 'Input')"
                                                @keyup.up="moveFocus($event, 'TextBox_4', 'Input')"
                                                @keyup.down="moveFocus($event, 'TextBox_12', 'Input')"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="p-field p-col-12 p-lg-3">
                                <label for="iev_update_info_date">วันที่สร้างข้อมูล <span class="required-input"> </span></label>
                                <InputText id="iev_update_info_date" type="text" v-model="csbForm_date_create" autofocus disabled />
                            </div>
                            <div class="p-field p-col-12 p-lg-3">
                                <label for="iev_update_info_date">{{ $t('imp_update_info_date') }} <span class="required-input"> </span></label>
                                <InputText id="iev_update_info_date" type="text" v-model="csbForm_date_update" autofocus disabled />
                            </div>
                        </div>

                        <div class="p-field p-col-12 p-lg-4 p-mt-3">
                            <label for="provinceOptions">{{ $t('province') }} <span class="required-input"> *</span></label>
                            <Dropdown
                                v-model="iie_selectedProvince"
                                @input="inputMap_PAT_latlon"
                                :options="provinceOptions"
                                @change="someHandler('ch-province')"
                                optionLabel="province_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :class="{
                                    'p-invalid': error_iie_selectedProvince && !iie_selectedProvince
                                }"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="provinceOptions">
                                    <div v-if="provinceOptions.value">
                                        <div>{{ provinceOptions.value.province_name }}</div>
                                    </div>
                                </template>
                                <template #option="provinceOptions">
                                    <div>{{ provinceOptions.option.province_name }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_iie_selectedProvince && !iie_selectedProvince">{{ 'กรุณาระบุจังหวัด' }}</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-4 p-mt-3">
                            <label for="amphurOptions">{{ $t('amphur') }} <span class="required-input"> *</span></label>
                            <Dropdown
                                :disabled="ira_isDisabledAmphur == 1"
                                v-model="iie_selectedAmphur"
                                @input="inputMap_PAT_latlon"
                                @change="someHandler('ch-amphur')"
                                :options="amphurOptions"
                                optionLabel="amphur_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :class="{
                                    'p-invalid': error_iie_selectedAmphur && !iie_selectedAmphur
                                }"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="amphurOptions">
                                    <div v-if="amphurOptions.value">
                                        <div>{{ amphurOptions.value.amphur_name }}</div>
                                    </div>
                                </template>
                                <template #option="amphurOptions">
                                    <div>{{ amphurOptions.option.amphur_name }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_iie_selectedAmphur && !iie_selectedAmphur">{{ 'กรุณาระบุเขต/อำเภอ' }}</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-4 p-mt-3">
                            <label for="tambonOptions">{{ $t('tambon') }} <span class="required-input"> *</span></label>
                            <Dropdown
                                :disabled="ira_isDisabledTambon == 1"
                                v-model="iie_selectedTambon"
                                @input="inputMap_PAT_latlon"
                                :options="tambonOptions"
                                optionLabel="tambon_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :class="{
                                    'p-invalid': error_iie_selectedTambon && !iie_selectedTambon
                                }"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="tambonOptions">
                                    <div v-if="tambonOptions.value">
                                        <div>{{ tambonOptions.value.tambon_name }}</div>
                                    </div>
                                </template>
                                <template #option="tambonOptions">
                                    <div>{{ tambonOptions.option.tambon_name }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_iie_selectedTambon && !iie_selectedTambon">{{ 'กรุณาระบุแขวง/ตำบล' }}</small>
                        </div>
                        <!-- Doe เพิ่มหมุด map V.2 1/9  @input="inputMap_PAT_latlon" จบ-->

                        <!-- Doe เพิ่ม สถานีดับเพลิงและกู้ภัย -->
                    </div>

                    <!-- Doe เพิ่มหมุด map V.2 2/9  @input="inputMap_latlon" -->
                    <div class="p-formgrid p-grid p-mt-3">
                        <div class="p-field p-col-12 p-lg-4">
                            <label for="iie_lat">{{ $t('lat') }}<span class="required-input"> *</span></label>
                            <InputText
                                id="iie_lat"
                                type="text"
                                v-model="iie_lat"
                                @input="inputMap_latlon"
                                :class="{
                                    'p-invalid': error_iie_lat && !iie_lat
                                }"
                                ref="TextBox_11"
                                @keyup.left="moveFocus($event, 'TextBox_10', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_12', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_9', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_14', 'Button')"
                            /><small class="p-invalid" v-if="error_iie_lat && !iie_lat">{{ 'กรุณาระบุ ค่าละติจูด' }}</small>
                        </div>
                        <div class="p-field p-col-12 p-lg-4">
                            <label for="iie_lon">{{ $t('lon') }}<span class="required-input"> *</span></label>
                            <InputText
                                id="iie_lon"
                                type="text"
                                v-model="iie_lon"
                                @input="inputMap_latlon"
                                :class="{
                                    'p-invalid': error_iie_lon && !iie_lon
                                }"
                                ref="TextBox_12"
                                @keyup.left="moveFocus($event, 'TextBox_11', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_13', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_10', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_14', 'Button')"
                            /><small class="p-invalid" v-if="error_iie_lon && !iie_lon">{{ 'กรุณาระบุ ค่าลองจิจูด' }}</small>
                        </div>
                        <!-- Doe เพิ่มหมุด map V.2 2/9  @input="inputMap_latlon" จบ-->

                        <!-- Doe:  เพิ่ม มุดmap 1/4 -->
                        <div class="p-field p-col-12 p-lg-4 p-mt-5">
                            <Button
                                @click="
                                    displayMap = true;
                                    sendM(iie_lat, iie_lon);
                                    sendM_PAT(iie_selectedTambon, iie_selectedAmphur, iie_selectedProvince);
                                "
                                icon="pi pi-map-marker"
                                :label="$t('openMapBtn')"
                                class="p-button-secondary"
                                ref="TextBox_13"
                                @keyup.left="moveFocus($event, 'TextBox_12', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_14', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_10', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_14', 'Button')"
                            />
                        </div>
                        <!-- Doe:  เพิ่ม มุดmap 1/4 จบ-->

                        <!-- Doe เพิ่มหมุด map V.2 3/9  -->
                        <small class="warningLATLON" v-if="this.error_latlon_P || this.error_latlon_A || this.error_latlon_T || error_latlon_country"
                            >ข้อควรระวัง : ข้อมูลพิกัดที่คุณเลือกไม่สามารถระบุ
                            <span v-if="this.error_latlon_P || error_latlon_country"> จังหวัด </span>
                            <span v-if="this.error_latlon_A || error_latlon_country"> เขต/อำเภอ </span>
                            <span v-if="this.error_latlon_T || error_latlon_country"> แขวง/ตำบล </span>
                            <span> ได้ </span>
                        </small>
                        <!-- Doe เพิ่มหมุด map V.2 3/9  จบ-->
                    </div>

                    <hr />

                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-12 p-lg-6">
                            <label>บัญชีจ่ายสิ่งของบริจาค</label>
                        </div>
                        <!-- <div class="p-field p-col-6 p-lg-2">
                <Button
                  @click="addMaintenanceHistoryModal = true"
                  icon="pi pi-plus"
                  :label="$t('addBtn')"
                  class="p-button-success"
                />
              </div> -->
                        <div class="p-field p-col-12 p-lg-6">
                            <div class="p-grid p-col" style="justify-content: flex-end">
                                <div class="p-col-12 p-lg-4 p-mt-2">
                                    <Button
                                        @click="setOpen_donatedItems_Modal('')"
                                        icon="pi pi-plus"
                                        :label="$t('addBtn')"
                                        class="p-button-success"
                                        ref="TextBox_14"
                                        @keyup.left="moveFocus($event, 'TextBox_13', 'Button')"
                                        @keyup.right="moveFocus($event, 'TextBox_15', 'Button')"
                                        @keyup.up="moveFocus($event, 'TextBox_13', 'Button')"
                                        @keyup.down="moveFocus($event, 'TextBox_15', 'Button')"
                                    />
                                </div>
                                <!-- <div class="p-col-12 p-lg-4 p-mt-2">
                    <Button
                      @click="exportCSV('dt_DI')"
                      :label="$t('exportBtn')"
                      style="background-color: green;
                             border: 1px solid green;"
                    />
                  </div>
                  <div class="p-col-12 p-lg-4 p-mt-2">
                    <SplitButton
                      :model="items_DI"
                      label="ส่งออก PDF"
                      class="p-button-raised p-button-danger "
                      style="background-color: #f33737; "
                    />
                  </div> -->
                            </div>
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-12">
                            <DataTable
                                :value="donatedItems_data"
                                scrollHeight="500px"
                                :paginator="true"
                                dataKey="id_DI"
                                sortField="index"
                                ref="dt_DI"
                                :exportFilename="`บัญชีจ่ายสิ่งของบริจาค-${date}`"
                                :rows="5"
                                :rowHover="true"
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                :rowsPerPageOptions="[5, 10, 20, 50]"
                                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
                            >
                                <template #empty>{{ $t('TableEmpty') }}</template>
                                <Column
                                    field="index"
                                    :header="'ลำดับ'"
                                    :sortable="true"
                                    :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')"
                                >
                                    <template #body="dataTable">
                                        <div class="table_row">
                                            {{ dataTable.data.index }}
                                        </div>
                                    </template>
                                </Column>
                                <Column
                                    field="date_ShowTable"
                                    :header="'วันที่จ่ายสิ่งของบริจาค'"
                                    :sortable="true"
                                    :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                                >
                                    <template #body="dataTable">
                                        {{ dataTable.data.date_ShowTable }}
                                    </template>
                                </Column>
                                <Column
                                    field="received_from"
                                    :header="'รับจาก'"
                                    :sortable="true"
                                    :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                                >
                                    <template #body="dataTable">
                                        {{ dataTable.data.received_from }}
                                    </template>
                                </Column>
                                <Column
                                    field="expiration_to"
                                    :header="'จ่ายให้'"
                                    :sortable="true"
                                    :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                                >
                                    <template #body="dataTable">
                                        {{ dataTable.data.expiration_to }}
                                    </template>
                                </Column>
                                <Column
                                    field="num_expense"
                                    :header="'จำนวน'"
                                    :sortable="true"
                                    :headerStyle="tableColSticky('10rem', 'center', 'sticky', 'top')"
                                >
                                    <template #body="dataTable">
                                        <div class="table_row">
                                            {{ parseInt(dataTable.data.num_expense).toLocaleString('en') }}
                                            <!-- {{ dataTable.data.num_expense }} -->
                                        </div>
                                    </template>
                                </Column>
                                <Column
                                    field="num_remaining"
                                    :header="'ยอดของคงเหลือ'"
                                    :sortable="true"
                                    :headerStyle="tableColSticky('15rem', 'center', 'sticky', 'top')"
                                >
                                    <template #body="dataTable">
                                        <div class="table_row">
                                            {{ dataTable.data.num_remaining.toLocaleString('en') }}
                                            <!-- {{ dataTable.data.num_remaining }} -->
                                        </div>
                                    </template>
                                </Column>
                                <Column
                                    field="unit"
                                    :header="'หน่วย'"
                                    :sortable="true"
                                    :headerStyle="tableColSticky('10rem', 'center', 'sticky', 'top')"
                                >
                                    <template #body="dataTable">
                                        <div class="table_row">
                                            {{ dataTable.data.unit }}
                                        </div>
                                    </template>
                                </Column>

                                <Column :header="$t('controlTable')" :headerStyle="table_headerStyle" :bodyStyle="table_bodyStyle">
                                    <template #body="dataTable">
                                        <div class="p-formgrid col_manege">
                                            <div :class="table_BOXmanege">
                                                <Button
                                                    @click="setOpen_donatedItems_Modal(dataTable.data.id_DI)"
                                                    icon="pi pi-pencil"
                                                    :label="table_editBTN"
                                                    class="p-button-rounded p-button-warning"
                                                />
                                            </div>
                                            <div :class="table_BOXmanege">
                                                <Button
                                                    @click="
                                                        // displayConfirmation = true;
                                                        deleteDonatedItems = dataTable.data;
                                                        deleteAt = 'donatedItems-table';

                                                        alertDisplay(deleteDonatedItems, deleteAt);
                                                    "
                                                    icon="pi pi-trash"
                                                    :label="table_deleteBTN"
                                                    class="p-button-rounded p-button-danger"
                                                />
                                            </div>
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                    </div>

                    <hr />
                </div>
            </div>
            <template #footer>
                <!-- โหลดเพิ่มแก้ไข 2/8-->
                <Button
                    v-if="selectedData != ''"
                    :label="$t('cancelBtn')"
                    icon="pi pi-times"
                    :disabled="loadingCreate ? true : false"
                    class="p-button-text"
                    @click="clearData()"
                    ref="TextBox_15"
                    @keyup.left="moveFocus($event, 'TextBox_14', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_16', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_14', 'Button')"
                />
                <Button
                    v-else
                    :label="$t('clearBtn')"
                    icon="pi pi-times"
                    :disabled="loadingCreate ? true : false"
                    class="p-button-text"
                    @click="clearData()"
                    ref="TextBox_15"
                    @keyup.left="moveFocus($event, 'TextBox_14', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_16', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_14', 'Button')"
                />
                <Button
                    :label="$t('saveBtn')"
                    :disabled="loadingCreate ? true : false"
                    icon="pi pi-check"
                    class="p-button-text"
                    @click="saveData()"
                    ref="TextBox_16"
                    @keyup.left="moveFocus($event, 'TextBox_15', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_1', 'Input')"
                    @keyup.up="moveFocus($event, 'TextBox_14', 'Button')"
                />
                <!-- โหลดเพิ่มแก้ไข 2/8 จบ-->
            </template>
        </Dialog>

        <!-- เพิ่มบัญชีจ่ายสิ่งของบริจาค -->
        <Dialog :modal="true" :visible.sync="donatedItems_Modal" :style="{ width: '700px' }" :header="header_DI">
            <div class="confirmation-content" @keyup.enter="saveData_Modal('Modal_DI')">
                <label>{{ $t('ide_modal_subtitle') }}</label>
                <div class="p-fluid p-mt-3">
                    <div class="p-formgrid p-grid p-col-12 p-grid">
                        <div class="p-field p-col-12 p-lg-6">
                            <label for="DI_date">วันที่จ่ายสิ่งของบริจาค <span class="required-input">*</span></label>
                            <!-- :minDate="csbForm_date_received" -->
                            <!-- :maxDate="csbForm_date_expiration" -->
                            <Calendar
                                dateFormat="dd/mm/yy"
                                :maxDate="setDateMax_csbForm(dataEdit_DI)"
                                :minDate="setDate_csbForm(dataEdit_DI)"
                                :manualInput="true"
                                :showButtonBar="true"
                                :monthNavigator="true"
                                :yearNavigator="true"
                                :yearRange="`2000:${setYearRange(date_yearRange, 1, 'plus')}`"
                                :locale="th"
                                v-model="DI_date"
                                :class="{
                                    'p-invalid': error_DI_date && !DI_date
                                }"
                            ></Calendar>
                            <small class="p-invalid" v-if="error_DI_date && !DI_date">กรุณาระบุ วันที่จ่ายสิ่งของบริจาค</small>
                        </div>
                        <div class="p-field p-col-12 p-lg-6">
                            <label for=" DI_received">รับจาก <span class="required-input">*</span></label>
                            <InputText
                                id=" DI_received"
                                type="text"
                                v-model="DI_received"
                                disabled
                                :class="{
                                    'p-invalid': error_DI_received && !DI_received
                                }"
                            />
                            <small class="p-invalid" v-if="error_DI_received && !DI_received">กรุณาระบุ รับจาก</small>
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-col-12 p-grid">
                        <div class="p-field p-col-12 p-lg-6">
                            <div style="display: flex">
                                <div style="width: calc(100% - 70px); margin-right: 7px">
                                    <label for="DI_give"
                                        >จ่ายให้
                                        <span class="required-input">*</span>
                                    </label>
                                    <InputText
                                        style="margin-top: 7px"
                                        id="DI_give"
                                        type="text"
                                        v-model="DI_give.name"
                                        disabled
                                        :class="{
                                            'p-invalid': error_DI_give && !DI_give.name
                                        }"
                                    />
                                    <small class="p-invalid" v-if="error_DI_give && !DI_give.name">กรุณาระบุ จ่ายให้</small>
                                </div>
                                <div style="width: 90px">
                                    <Button
                                        @click="
                                            showOrganize_Form = true;
                                            setOpenModal_Organize = 'give';
                                        "
                                        icon="pi pi-ellipsis-h"
                                        class="p-button-secondary p-mt-5 p-mr-2"
                                        ref="TextBox_1_DI"
                                        @keyup.left="moveFocus($event, 'TextBox_5_DI', 'Button')"
                                        @keyup.right="moveFocus($event, 'TextBox_2_DI', 'Button')"
                                        @keyup.down="moveFocus($event, 'TextBox_4_DI', 'Button')"
                                    />
                                    <Button
                                        @click="DI_give = {}"
                                        icon="pi pi-times"
                                        class="p-button-danger p-mt-5"
                                        ref="TextBox_2_DI"
                                        @keyup.left="moveFocus($event, 'TextBox_1_DI', 'Button')"
                                        @keyup.right="moveFocus($event, 'TextBox_3_DI', 'InputNumber')"
                                        @keyup.down="moveFocus($event, 'TextBox_4_DI', 'Button')"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="p-field p-col-12 p-lg-6">
                            <label for="DI_count">จำนวน <span class="required-input">*</span> </label>
                            <!-- <InputText
                  id="DI_count"
                  type="text"
                  v-model="DI_count"
                  @input="acceptNumber2()"
                  min="0.00"
                  :class="{
                            'p-invalid': error_DI_count && !DI_count,
                          }"
                /> -->
                            <InputNumber
                                id="DI_count"
                                v-model="DI_count"
                                :min="0"
                                :class="{
                                    'p-invalid': error_DI_count && !DI_count
                                }"
                                ref="TextBox_3_DI"
                                @keyup.left="moveFocus($event, 'TextBox_2_DI', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_4_DI', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_5_DI', 'Button')"
                            />
                            <small class="p-invalid" v-if="error_DI_count && !DI_count">กรุณาระบุ จำนวน</small>
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-col-12 p-grid">
                        <div class="p-field p-col-12 p-lg-6">
                            <label for="csbForm_remaining_balance">ยอดของคงเหลือ</label>
                            <!-- <InputText
                  id="csbForm_remaining_balance"
                  type="text"
                  v-model="total"
                  disabled
                  min="0.00"
                /> -->
                            <InputNumber id="csbForm_remaining_balance" v-model="total" disabled :min="0" />
                        </div>

                        <div class="p-field p-col-12 p-lg-6">
                            <label for="Maintenance_unit">หน่วยนับ</label>
                            <InputText type="text" :value="Maintenance_unit !== null ? Maintenance_unit.system_name : ''" disabled />
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <div class="DI_Modal">
                    <div class="DI_Modal_errorText" v-if="parseInt(DI_count) > parseInt(csbForm_remaining_balance)">
                        *กรุณาระบุ ข้อมูลจำนวน น้อยกว่า ข้อมูลยอดของคงเหลือ
                    </div>
                    <div v-else></div>
                    <div>
                        <Button
                            v-if="Object.keys(dataEdit_DI).length !== 0"
                            :label="'ยกเลิก'"
                            icon="pi pi-times"
                            class="p-button-text"
                            @click="donatedItems_Modal = false"
                            ref="TextBox_4_DI"
                            @keyup.left="moveFocus($event, 'TextBox_3_DI', 'InputNumber')"
                            @keyup.right="moveFocus($event, 'TextBox_5_DI', 'Button')"
                            @keyup.up="moveFocus($event, 'TextBox_3_DI', 'InputNumber')"
                        />
                        <Button
                            v-else
                            :label="$t('clearBtn')"
                            icon="pi pi-times"
                            class="p-button-text"
                            @click="clearSubData()"
                            ref="TextBox_4_DI"
                            @keyup.left="moveFocus($event, 'TextBox_3_DI', 'InputNumber')"
                            @keyup.right="moveFocus($event, 'TextBox_5_DI', 'Button')"
                            @keyup.up="moveFocus($event, 'TextBox_3_DI', 'InputNumber')"
                        />
                        <Button
                            :label="$t('saveBtn')"
                            icon="pi pi-check"
                            class="p-button-text"
                            @click="saveDonatedItems()"
                            ref="TextBox_5_DI"
                            @keyup.left="moveFocus($event, 'TextBox_4_DI', 'Button')"
                            @keyup.right="moveFocus($event, 'TextBox_1_DI', 'Button')"
                            @keyup.up="moveFocus($event, 'TextBox_3_DI', 'InputNumber')"
                        />
                    </div>
                </div>
            </template>
        </Dialog>

        <Dialog :modal="true" :header="$t('map')" :visible.sync="displayMap" :style="{ width: '700px', overflow: 'auto' }">
            <div class="confirmation-content p-mt-3" style="padding-bottom: 20px">
                <!-- Doe : เพิ่ม มุดmap 2/4 -->
                <!-- Doe เพิ่มหมุด map V.2 4/9  -->
                <map-area @selectMap="selectMap_passValue" :latlon="this.latlon" :PAT="this.PAT" :FSS="{}" @selectMap_PAT="receiveM_PAT"></map-area>
                <!-- <map-area @selectMap="selectMap_passValue" :latlon="this.latlon"  ></map-area> -->
                <!-- Doe เพิ่มหมุด map V.2 4/9  จบ-->
                <!-- Doe :  เพิ่ม มุดmap 2/4 -->
            </div>
            <Button :label="$t('saveBtn')" icon="pi pi-check" class="p-button-text" @click="selectMap_displayMap()" />
        </Dialog>

        <!-- Image -->
        <Dialog :modal="true" :header="$t('imageEquipment')" :visible.sync="displayImageModal" :style="{ width: '400px' }">
            <div class="img-content p-mt-5 p-mb-5">
                <img :src="imgEquipment" alt="" v-if="imgEquipment" />
                <div v-else class="p-text-center">{{ $t('NoImageEquipment') }}</div>
            </div>
        </Dialog>

        <Galleria
            :value="imgTable"
            containerStyle="max-width: 850px"
            :circular="true"
            :fullScreen="true"
            :showItemNavigators="false"
            :showThumbnails="false"
            :visible.sync="displayBasic2"
        >
            <template #item="slotProps">
                <img :src="imgTable" class="imgDia" alt="" />
            </template>
        </Galleria>

        <!-- Doe PDF เลือกได้  -->
        <Dialog header="ตั้งค่า " :visible.sync="displayEditPDF" :style="{ width: '25rem' }" :contentStyle="{ 'overflow-y': 'visible' }">
            <label>ตั้งค่าการแสดงข้อมูลตารางและการส่งออกข้อมูล</label>
            <div style="margin: 2.5rem 1rem 0 1rem">
                <div class="p-formgrid p-grid">
                    <div class="p-field p-col-12">
                        <MultiSelect
                            v-model="columnsSelectorDialog"
                            :options="columns"
                            optionLabel="title"
                            :placeholder="$t('placeholderSelectBox')"
                            :filter="true"
                            class="multiselect-custom"
                            :clearFilterMultiSelect="multiSelectClearFilerValue"
                        >
                            <template #value="slotProps">
                                <div class="item item-value" v-for="option of slotProps.value" :key="option.dataKey">
                                    <div>{{ option.title }}</div>
                                </div>
                                <template v-if="!slotProps.value || slotProps.value.length === 0">
                                    {{ $t('placeholderSelectBox') }}
                                </template>
                            </template>
                            <template #option="slotProps">
                                <div class="item">
                                    <div>{{ slotProps.option.title }}</div>
                                </div>
                            </template>
                        </MultiSelect>
                        <div style="margin-top: 1rem; display: flex; justify-content: flex-end">
                            <Button
                                @click="
                                    ClearEditPDF();
                                    multiSelectClearFilerValue += 1;
                                "
                                class="p-button-clear"
                                :label="'ล้างข้อมูล'"
                                style="margin-right: 1rem"
                            />
                            <Button @click="SelectAllEditPDF()" class="p-button-info" :label="'เลือกทั้งหมด'" />
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <div>
                    <Button @click="CloseEditPDF()" :label="'ยกเลิก'" icon="pi pi-times" class="p-button-text" />
                    <Button @click="SaveEditPDF()" :label="'บันทึก'" icon="pi pi-check" class="p-button-text" />
                </div>
            </template>
        </Dialog>
        <!-- Doe PDF เลือกได้ -->

        <!-- Modal export -->
        <Dialog :modal="true" :header="'ส่งออก'" :visible.sync="modalExport_Form" :style="{ width: '300px' }">
            <div style="margin: 0px 0px 1rem 0px">บัญชีจ่ายสิ่งของบริจาค({{ csbForm_itemName }})</div>
            <div style="padding-bottom: 7px; display: block; text-align: center">
                <div style="width: 100%">
                    <download-excel
                        class="p-button-info"
                        :data="exportExcel_Form(JSON.parse(JSON.stringify(donatedItems_data)))"
                        :fields="columns_DI"
                        :header="exportExcel_Form_Header(csbForm_itemName)"
                        :name="`บัญชีจ่ายสิ่งของบริจาค-${date}.xls`"
                        :type="'xls'"
                    >
                        <Button :label="$t('exportBtn')" style="background-color: green; border: 1px solid green; width: 100%" />
                    </download-excel>

                    <!-- <Button :label="$t('exportBtn')" 
                        @click="exportFile('xlsx')"
                        style="background-color: green;
                        border: 1px solid green;
                        width: 100%;"
                    /> -->
                </div>

                <div class="">
                    <SplitButton
                        :model="items_DI"
                        label="ส่งออก PDF"
                        class="p-button-raised p-button-danger"
                        style="background-color: #f33737; width: 100%"
                    />
                </div>
                <!-- style="display: none;" -->
                <table id="tbl_DI">
                    <div class="p-formgrid p-grid p-col-12" style="display: none">
                        <div class="p-field p-col-12">
                            <DataTable
                                :value="this.exportExcel_Form(JSON.parse(JSON.stringify(donatedItems_data)))"
                                scrollHeight="500px"
                                dataKey="id_DI"
                                sortField="index"
                                ref="dt_DI"
                                :exportFilename="`บัญชีจ่ายสิ่งของบริจาค-${date}`"
                                :rows="5"
                                :rowHover="true"
                            >
                                <template #empty>{{ $t('TableEmpty') }}</template>
                                <ColumnGroup type="header">
                                    <Row>
                                        <Column
                                            field=""
                                            :header="exportExcel_Form_Header(csbForm_itemName)"
                                            :colspan="7"
                                            :sortable="true"
                                            headerStyle="text-align:center;"
                                        />
                                    </Row>
                                    <Row>
                                        <Column field="index" :header="'ลำดับ'" :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')" />
                                        <Column
                                            field="date"
                                            :header="'วันที่จ่ายสิ่งของบริจาค'"
                                            :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')"
                                        />
                                        <Column
                                            field="received_from"
                                            :header="'รับจาก'"
                                            :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')"
                                        />
                                        <Column
                                            field="expiration_to"
                                            :header="'จ่ายให้'"
                                            :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')"
                                        />
                                        <Column
                                            field="num_expense"
                                            :header="'จำนวน'"
                                            :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')"
                                        />
                                        <Column
                                            field="num_remaining"
                                            :header="'ยอดคงเหลือ'"
                                            :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')"
                                        />
                                        <Column field="unit" :header="'หน่วย'" :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')" />
                                    </Row>
                                </ColumnGroup>

                                <Column
                                    field="index"
                                    :header="'ลำดับ'"
                                    :sortable="true"
                                    :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')"
                                >
                                    <template #body="dataTable">
                                        <div class="table_row">
                                            {{ dataTable.data.index }}
                                        </div>
                                    </template>
                                </Column>
                                <Column
                                    field="date_ShowTable"
                                    :header="'วันที่จ่ายสิ่งของบริจาค'"
                                    :sortable="true"
                                    :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                                >
                                    <template #body="dataTable">
                                        {{ dataTable.data.date_ShowTable }}
                                    </template>
                                </Column>
                                <Column
                                    field="received_from"
                                    :header="'รับจาก'"
                                    :sortable="true"
                                    :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                                >
                                    <template #body="dataTable">
                                        {{ dataTable.data.received_from }}
                                    </template>
                                </Column>
                                <Column
                                    field="expiration_to"
                                    :header="'จ่ายให้'"
                                    :sortable="true"
                                    :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                                >
                                    <template #body="dataTable">
                                        {{ dataTable.data.expiration_to }}
                                    </template>
                                </Column>
                                <Column
                                    field="num_expense"
                                    :header="'จำนวน'"
                                    :sortable="true"
                                    :headerStyle="tableColSticky('10rem', 'center', 'sticky', 'top')"
                                >
                                    <template #body="dataTable">
                                        <div class="table_row">
                                            {{ dataTable.data.num_expense }}
                                        </div>
                                    </template>
                                </Column>
                                <Column
                                    field="num_remaining"
                                    :header="'ยอดของคงเหลือ'"
                                    :sortable="true"
                                    :headerStyle="tableColSticky('15rem', 'center', 'sticky', 'top')"
                                >
                                    <template #body="dataTable">
                                        <div class="table_row">
                                            {{ dataTable.data.num_remaining }}
                                        </div>
                                    </template>
                                </Column>
                                <Column
                                    field="unit"
                                    :header="'หน่วย'"
                                    :sortable="true"
                                    :headerStyle="tableColSticky('10rem', 'center', 'sticky', 'top')"
                                >
                                    <template #body="dataTable">
                                        <div class="table_row">
                                            {{ dataTable.data.unit }}
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                    </div>
                </table>
            </div>
        </Dialog>
    </div>
</template>

<script>
import organizeForm from '../OrganizeTableForm.vue';
import organizeTable from '../../Report/OrganizeMultiSelectTable.vue';
import mapArea from '../Map';
// Doe : PDF 2/3
// เพิ่ม pdf กับ font
// import { jsPDF } from "jspdf";
// import {font} from '../../../../public/assets/font/Sarabun-Regular-normal';
// Doe : PDF 2/3 จบ
import moment from 'moment';
import * as XLSX from 'xlsx';

import textFooter from '../../../mixins/textFooter_Search_html';

export default {
    name: 'initial-consumables',
    components: {
        organizeTable,
        organizeForm,
        mapArea,
        textFooter
    },
    data() {
        return {
            selectedConsumables: [],
            multiSelectClearFilerValue: 0,
            date: moment().locale('th').add(543, 'year').format('l'),
            date_yearRange: new Date(),
            pic: '',
            // Doe ค้นหา  2/5
            dropdownClearFilerValue: 0,
            filter: '',
            ms: false,
            cloneTable: [],
            // Doe ค้นหา  2/5 จบ

            // Doe โหลด โทรศัพท์
            // Doe width 1/4
            window: {
                width: 0,
                height: 0
            },
            startDate: null,
            toDate: null,
            //Search bar variable
            checkRole: null,
            checkView_data: null,
            checkAdd_data: null,
            checkEdit_data: null,
            checkDelete_data: null,
            th: this.$thaidate,
            selectedOrganize: {},
            //
            displayConfirmation: false,
            filters: {},

            showOrganize: false,
            showOrganize_Form: false,
            selectedData: '',

            url: null,

            iev_organize: {},
            error_iev_organize: false,

            deleteAt: '',

            header: 'เพิ่มข้อมูล เครื่องอุปโภค บริโภค',

            tempFor_displayConfirmationCloseModal: '',
            minDate: null,
            maxDate: null,
            // minDate: "",
            // maxDate: "",

            unitNameOptions: [],

            // new
            setOpenModal_Organize: '',
            setOpenModal_OrganizeMulti: '',
            consumables_Table: [],

            // search
            csb_itemName: '',
            csb_sourceType_Option: ['รับบริจาค', 'จัดซื้อจัดจ้าง'],
            csb_sourceType_Selector: null,
            csb_source_location: '',
            csb_storage_location: {},
            csb_receivedDate: null,
            csb_expirationDate: null,
            csb_consumables_code: '',

            // Form
            header_DI: 'เพิ่มข้อมูล บัญชีจ่ายสิ่งของบริจาค',
            consumables_TableModal: false,
            dataEdit_DI: {},

            csbForm_itemName: '',
            error_csbForm_itemName: false,

            csbForm_consumables_code: '',

            // csbForm_quantity:"",
            csbForm_quantity: 0,
            error_Over_quantity: false,
            error_csbForm_quantity: false,

            csbForm_total_expense: 0,
            csbForm_remaining_balance: 0,

            Maintenance_unit: null,
            error_csbForm_Maintenance_unit: false,

            csbForm_source_type: null,
            error_csbForm_source_type: false,

            csbForm_date_received: null,
            error_csbForm_date_received: false,
            check_date_received: false,
            DataError_date_received: [],

            csbForm_date_expiration: null,
            csbForm_source_location: '',
            error_csbForm_source_location: false,

            csbForm_storage_location: {},
            error_csbForm_storage_location: false,

            csbForm_date_create: '',
            csbForm_date_update: '',

            csb_cal: [],
            deleteDonatedItems: {},
            // province

            provinceOptions: [],
            iie_selectedProvince: null,
            error_iie_selectedProvince: false,

            amphurOptions: [],
            iie_selectedAmphur: null,
            error_iie_selectedAmphur: false,

            tambonOptions: [],
            iie_selectedTambon: null,
            error_iie_selectedTambon: false,

            ira_isDisabledAmphur: 1,
            ira_isDisabledTambon: 1,

            //  Doe เพิ่มหมุด map V.2 5/9  -->
            displayMap: false,

            iie_lat: '',
            iie_lon: '',
            error_iie_lat: false,
            error_iie_lon: false,

            latlon: {},
            PAT: {},
            sP: [],
            sA: [],
            error_latlon_country: false,
            error_latlon_land: false,
            error_latlon_P: false,
            error_latlon_A: false,
            error_latlon_T: false,
            //  Doe เพิ่มหมุด map V.2 5/9  จบ-->

            // บัญชีจ่ายสิ่งของบริจาค
            donatedItems_Modal: false,
            donatedItems_data: [],
            columns_DI: {
                ลำดับ: 'index',
                วันที่จ่ายสิ่งของบริจาค: 'date',
                รับจาก: 'received_from',
                จ่ายให้: 'expiration_to',
                จำนวน: 'num_expense',
                ยอดคงเหลือ: 'num_remaining',
                หน่วย: 'unit'
            },
            columns_DI_new: ['ลำดับ', 'วันที่จ่ายสิ่งของบริจาค', 'รับจาก', 'จ่ายให้', 'จำนวน', 'ยอดคงเหลือ', 'หน่วย'],
            // บัญชีจ่ายสิ่งของบริจาค Form
            DI_date: null,
            error_DI_date: false,
            DI_received: '',
            error_DI_received: false,
            DI_give: {},
            error_DI_give: false,
            // DI_count:"",
            DI_count: 0,
            error_DI_count: false,

            DI_total: '',
            DI_unit: '',

            total: 0,
            checkEdit_DI_count: true,
            array_DI_count: [],

            // PDF in Form

            modalExport_Form: false,

            columns_Form: [
                { title: 'ลำดับ', dataKey: 'index' },
                { title: 'วันที่จ่ายสิ่งของบริจาค', dataKey: 'date_ShowTable' },
                { title: 'รับจาก', dataKey: 'received_from' },
                { title: 'จ่ายให้', dataKey: 'expiration_to' },
                { title: 'จำนวน', dataKey: 'num_expense' },
                { title: 'ยอดของคงเหลือ', dataKey: 'num_remaining' },
                { title: 'หน่วย', dataKey: 'unit' }
            ],
            PDF_BodySize_Form: {
                index: { cellWidth: 35 }
            },
            setPDF_Form_ColFont: 15,
            setPDF_Form_BodyFont: 12,
            setPDF_Form_minCellWidth: 70,
            setPDF_Form_Margin: { left: 15, right: 15 },
            setPDF_Form_fillColor: [95, 154, 250],
            setnamePDF_Form: 'บัญชีจ่ายสิ่งของบริจาค',
            //
            // ******************************

            // -------------------------------

            displayImageModal: false,
            imgEquipment: null,
            temp: null,

            loading: false,

            selectedOrganizeData: [],
            organize_table: [],
            parentmessage_organize: null,

            // โหลดเพิ่มแก้ไข 3/8
            loadingCreate: false,
            // โหลดเพิ่มแก้ไข 3/8 จบ
            // Doe : PDF 3/3
            setPDF_Hor: 'l',
            setPosition_Hor: [802, 34, 802, 570],
            setPDF_Ver: 'p',
            setPosition_Ver: [570, 34, 575, 815],
            setPDF_Styles: 'grid',
            setnamePDF: 'ตารางข้อมูลเครื่องอุปโภค บริโภค',
            setPDF_fillColor: [95, 154, 250],
            setPDF_Margin: { left: 15, right: 15 },

            //
            text_Footer: false,
            Clone_Data_text_Footer: [],
            Data_text_Footer: [
                {
                    DataName: 'หน่วยงานที่รับผิดชอบ',
                    textShow: ''
                },
                {
                    DataName: 'รายการ',
                    textShow: ''
                },
                {
                    DataName: 'ประเภทที่มา',
                    textShow: ''
                },
                {
                    DataName: 'แหล่งที่มา',
                    textShow: ''
                },
                {
                    DataName: 'สถานที่จัดเก็บ',
                    textShow: ''
                },
                {
                    DataName: 'วันที่ได้รับ',
                    textShow: ''
                },
                {
                    DataName: 'วันหมดอายุ',
                    textShow: ''
                },
                {
                    DataName: 'เลขทะเบียนทรัพย์สิน',
                    textShow: ''
                }
            ],

            table_BOXmanege: window.innerWidth > 700 ? 'p-field p-col' : '',
            table_editBTN: window.innerWidth > 700 ? this.$i18n.t('editBtn') : '',
            table_deleteBTN: window.innerWidth > 700 ? this.$i18n.t('deleteBtn') : '',
            table_loadBTN: window.innerWidth > 700 ? 'ส่งออก' : '',

            table_headerStyle: this.checkInnerWidth('15rem', 'Column'),
            table_bodyStyle: this.checkInnerWidth('15rem', 'Body'),

            // Doe PDF เลือกได้  2/5
            PDF_minCellWidthVer: 40,
            PDF_FontHeaderVer: 7.5,
            PDF_FontBodyVer: 5.5,

            PDF_BodySizeSelect: {},
            PDF_BodySize: {
                index: { cellWidth: 21.5 },
                date_received: { cellWidth: 40 },
                item_name: { cellWidth: 35 },
                quantity: { cellWidth: 25 },
                total_expense: { cellWidth: 27 },
                remaining_balance: { cellWidth: 24 },
                unit: { cellWidth: 25 },
                date_expiration: { cellWidth: 25 },
                source_type: { cellWidth: 30 },
                organize_lat: { cellWidth: 30 },
                organize_lon: { cellWidth: 30 },
                consumables_code: { cellWidth: 35 },
                organize_name: { cellWidth: 40 },
                date_create_consumables: { cellWidth: 42 },
                date_update_consumables: { cellWidth: 38 },
                user_fullname: { cellWidth: 30 }
            },

            PDF_minCellWidthHor: 50,
            PDF_FontHeaderHor: 10,
            PDF_FontBodyHor: 8,

            PDF_BodySizeHorSelect: {},
            PDF_BodySizeHor: {
                index: { cellWidth: 32 },

                date_received: { cellWidth: 45 },

                quantity: { cellWidth: 40 },
                total_expense: { cellWidth: 40 },
                remaining_balance: { cellWidth: 50 },
                unit: { cellWidth: 38 },
                date_expiration: { cellWidth: 32 },
                organize_lat: { cellWidth: 38 },
                organize_lon: { cellWidth: 38 },
                source_type: { cellWidth: 38 },

                consumables_code: { cellWidth: 43 },
                organize_name: { cellWidth: 70 },
                date_create_consumables: { cellWidth: 58 },
                date_update_consumables: { cellWidth: 63 },
                user_fullname: { cellWidth: 48 }
            },
            columns: [
                { title: 'ลำดับ', dataKey: 'index' },
                { title: 'รูปภาพ', dataKey: 'image' },
                { title: 'วันที่ได้รับ', dataKey: 'date_received' },
                { title: 'รายการ', dataKey: 'item_name' },
                { title: 'จำนวน', dataKey: 'quantity' },
                { title: 'จ่ายออก', dataKey: 'total_expense' },
                { title: 'ยอดคงเหลือ', dataKey: 'remaining_balance' },
                { title: 'หน่วย', dataKey: 'unit' },
                { title: 'วันหมดอายุ', dataKey: 'date_expiration' },
                { title: 'สถานที่จัดเก็บ', dataKey: 'storage_location' },
                { title: 'ละติจูด', dataKey: 'organize_lat' },
                { title: 'ลองจิจูด', dataKey: 'organize_lon' },

                { title: 'ประเภทที่มา', dataKey: 'source_type' },
                { title: 'แหล่งที่มา', dataKey: 'source_location' },
                { title: 'เลขทะเบียนทรัพย์สิน', dataKey: 'consumables_code' },
                { title: 'หน่วยงาน', dataKey: 'organize_name' },
                { title: 'วันที่สร้างข้อมูล', dataKey: 'date_create_consumables' },
                { title: 'วันที่ปรับปรุงข้อมูลล่าสุด', dataKey: 'date_update_consumables' },
                { title: 'ผู้แก้ไข', dataKey: 'user_fullname' }
            ],

            columnsSelector: null,
            columnsSelectorDialog: null,

            displayEditPDF: false,

            columns_index: true,
            columns_img: true,
            columns_date_received: true,
            columns_item_name: true,
            columns_quantity: true,
            columns_total_expense: true,
            columns_remaining_balance: true,
            columns_unit: true,
            columns_date_expiration: true,
            columns_storage_location: true,
            columns_lat: true,

            columns_lon: true,

            columns_source_type: true,

            columns_source_location: true,
            columns_consumables_code: true,
            columns_organize_name: true,
            columns_date_create_consumables: true,

            columns_date_update_consumables: true,
            columns_ev_response_phone: true,

            columns_editor: true,

            columns_disabled: true,
            GetData_ColumnsSearch: [],

            imgTable: null,
            displayBasic2: false,
            // Doe PDF เลือกได้  2/5  จบ

            items: [
                {
                    label: ' แนวตั้ง',
                    command: () => {
                        this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวตั้ง', life: 3000 });

                        let columns = this.columnsSelector;
                        columns = columns.filter(function (item) {
                            return item.dataKey != 'image';
                        });

                        const Body_setCenter = ['index', 'quantity', 'total_expense', 'remaining_balance', 'unit', 'consumables_code'];

                        const PintPDF = {
                            streak: this.setPDF_Ver,
                            setPosition: this.setPosition_Ver,
                            PDF_Styles: this.setPDF_Styles,
                            data: this.$refs.dt.processedData,
                            columns: columns,
                            columnsStyles: this.PDF_BodySizeSelect,
                            FileName: this.setnamePDF,
                            checkBody_Center: true,
                            Body_Center: Body_setCenter,
                            Col_FontSize: this.PDF_FontHeaderVer,
                            Body_FontSize: this.PDF_FontBodyVer,
                            minCell: this.PDF_minCellWidthVer,
                            marginPDF: this.setPDF_Margin,
                            fillColorPDF: this.setPDF_fillColor
                        };
                        this.printPDF(PintPDF);
                    }
                },

                {
                    label: 'แนวนอน',
                    command: () => {
                        this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวนอน', life: 3000 });

                        let columns = this.columnsSelector;
                        columns = columns.filter(function (item) {
                            return item.dataKey != 'image';
                        });

                        const Body_setCenter = ['index', 'quantity', 'total_expense', 'remaining_balance', 'unit', 'consumables_code'];
                        const PintPDF = {
                            streak: this.setPDF_Hor,
                            setPosition: this.setPosition_Hor,
                            PDF_Styles: this.setPDF_Styles,
                            data: this.$refs.dt.processedData,
                            columns: columns,
                            columnsStyles: this.PDF_BodySizeHorSelect,
                            FileName: this.setnamePDF,
                            checkBody_Center: true,
                            Body_Center: Body_setCenter,
                            Col_FontSize: this.PDF_FontHeaderHor,
                            Body_FontSize: this.PDF_FontBodyHor,
                            minCell: this.PDF_minCellWidthHor,
                            marginPDF: this.setPDF_Margin,
                            fillColorPDF: this.setPDF_fillColor
                        };
                        this.printPDF(PintPDF);
                    }
                }
            ],
            items_DI: [
                {
                    label: 'แนวตั้ง',
                    command: () => {
                        this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวตั้ง', life: 3000 });

                        let columns = this.columns_Form;
                        const Body_setCenter = ['index', 'num_expense', 'num_remaining', 'unit'];

                        const margin_test = {
                            top: 70,
                            right: 15,
                            left: 15
                        };
                        const setTextHeader_allPages = `บัญชีจ่ายสิ่งของบริจาค (${this.csbForm_itemName})`;

                        const PintPDF = {
                            streak: this.setPDF_Ver,
                            setPosition: this.setPosition_Ver,
                            PDF_Styles: this.setPDF_Styles,
                            data: this.exportPDF_Form(JSON.parse(JSON.stringify(this.donatedItems_data))),
                            columns: columns,
                            columnsStyles: this.PDF_BodySize_Form,
                            FileName: this.setnamePDF_Form,
                            checkBody_Center: true,
                            Body_Center: Body_setCenter,
                            Col_FontSize: this.setPDF_Form_ColFont,
                            Body_FontSize: this.setPDF_Form_BodyFont,
                            minCell: this.setPDF_Form_minCellWidth,
                            // marginPDF:this.setPDF_Form_Margin,
                            marginPDF: margin_test,
                            fillColorPDF: this.setPDF_Form_fillColor,
                            //
                            // startMargin:60,
                            textHeader_allPages: true,
                            setTextHeader_allPages: setTextHeader_allPages
                        };
                        this.printPDF(PintPDF);
                    }
                },
                {
                    label: 'แนวนอน',
                    command: () => {
                        this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวนอน', life: 3000 });
                        let columns = this.columns_Form;
                        const Body_setCenter = ['index', 'num_expense', 'num_remaining', 'unit'];

                        const margin_test = {
                            top: 70,
                            right: 15,
                            left: 15
                        };
                        const setTextHeader_allPages = `บัญชีจ่ายสิ่งของบริจาค (${this.csbForm_itemName})`;

                        const PintPDF = {
                            streak: this.setPDF_Hor,
                            setPosition: this.setPosition_Hor,
                            PDF_Styles: this.setPDF_Styles,
                            data: this.exportPDF_Form(JSON.parse(JSON.stringify(this.donatedItems_data))),
                            columns: columns,
                            columnsStyles: this.PDF_BodySize_Form,
                            FileName: this.setnamePDF_Form,
                            checkBody_Center: true,
                            Body_Center: Body_setCenter,
                            Col_FontSize: this.setPDF_Form_ColFont,
                            Body_FontSize: this.setPDF_Form_BodyFont,
                            minCell: this.setPDF_Form_minCellWidth,
                            // marginPDF:this.setPDF_Form_Margin,
                            marginPDF: margin_test,
                            fillColorPDF: this.setPDF_Form_fillColor,
                            //
                            textHeader_allPages: true,
                            setTextHeader_allPages: setTextHeader_allPages
                        };
                        this.printPDF(PintPDF);
                    }
                }
            ]
            // Doe : PDF 3/3 จบ
        };
    },
    watch: {
        async consumables_TableModal(val) {
            if (val == false) {
                if (
                    this.tempFor_displayConfirmationCloseModal == '' &&
                    this.selectedData == '' &&
                    this.csbForm_itemName != '' &&
                    this.iev_organize.name != undefined &&
                    this.csbForm_quantity != 0 &&
                    this.Maintenance_unit != null &&
                    this.csbForm_source_type != null &&
                    this.csbForm_storage_location.name != undefined &&
                    this.iie_selectedProvince != null &&
                    this.iie_selectedAmphur != null &&
                    this.iie_selectedTambon != null &&
                    this.iie_lat != '' &&
                    this.iie_lon != ''
                ) {
                    // this.displayConfirmationCloseModal = true;
                    this.$fire({
                        title: 'ยืนยันการปิดหน้าต่างจัดการข้อมูล',
                        text: 'คุณต้องการออกจากการจัดการข้อมูลใช่หรือไม่ ?',

                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'ตกลง',
                        cancelButtonText: 'ยกเลิก'
                    }).then((result) => {
                        if (result.value) {
                            this.clear_data();
                        } else {
                            this.consumables_TableModal = true;
                        }
                    });
                } else {
                    this.clearData();
                }
            } else {
                if (this.temp === null) {
                    this.csbForm_date_create = this.checkDate_showEN(new Date());
                    this.csbForm_date_update = this.checkDate_showEN(new Date());

                    this.decodeToken = this.decodeJWT(localStorage.getItem('token'));

                    this.iev_organize = {
                        id: this.decodeToken.organize_id,
                        name: this.decodeToken.organize_name
                    };
                }

                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: { topic: 'get-province' }
                    })
                    .then((response) => {
                        (this.provinceOptions = response.data.data),
                            this.provinceOptions.splice(0, 0, {
                                province_id: 'getall',
                                province_name: this.$i18n.t('selectAll')
                            });
                    });
                await this.axios
                    .post(`${this.$url_service}/initial/option`, {
                        body: { group: 'dg-02' }
                    })
                    .then((response) => {
                        (this.disasterOptions = response.data.data),
                            this.disasterOptions.splice(0, 0, {
                                system_id: 'getall',
                                system_name: this.$i18n.t('selectAll')
                            });
                    });
            }
        },
        async modalExport_Form(val) {
            if (!val) {
                this.clear_data();
            }
        },

        async iie_selectedProvince(val) {
            if (val != null) {
                this.ira_isDisabledAmphur = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-amphur',
                            province_id: this.iie_selectedProvince.province_id
                        }
                    })
                    .then((response) => (this.amphurOptions = response.data.data));
            } else {
                this.ira_isDisabledAmphur = 1;
                this.iie_selectedAmphur = null;
            }
        },

        async iie_selectedAmphur(val) {
            if (val != null) {
                this.ira_isDisabledTambon = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-tambon',
                            amphur_id: this.iie_selectedAmphur.amphur_id
                        }
                    })
                    .then((response) => (this.tambonOptions = response.data.data));
            } else {
                this.ira_isDisabledTambon = 1;
                this.iie_selectedTambon = null;
            }
        },

        displayConfirmationCloseModal(val) {
            if (val == true) {
                this.consumables_TableModal = true;
            }
        },

        // Doe PDF เลือกได้
        columnsSelector(val) {
            if (val.length == 0) {
                this.consumables_Table = [];
            } else {
                this.consumables_Table = this.cloneTable;
            }
        },
        showOrganize(val) {
            if (val == true) {
                if (this.organize_table.length > 0) {
                    this.parentmessage_organize = this.organize_table;
                } else {
                    this.parentmessage_organize = [];
                }
            }
        },

        csbForm_date_received(val) {
            if (this.donatedItems_data.length !== 0) {
                this.reDate_received(val);
            }
        },
        donatedItems_Modal(val) {
            if (!val) {
                if (Object.keys(this.dataEdit_DI).length !== 0) {
                    if (this.checkEdit_DI_count) {
                        this.csb_cal.push(parseInt(this.dataEdit_DI[0].num_expense));
                        this.calTotal_expense(this.csb_cal);
                        this.checkEdit_DI_count = false;
                    }

                    this.re_csbForm_quantity(this.csbForm_quantity);
                    this.re_csb_cal(this.donatedItems_data);
                    this.dataEdit_DI = {};
                    this.checkEdit_DI_count = true;
                }

                this.clearSubData();
            } else {
                this.FocusRef_delay('TextBox_1_DI', 'Button');
                this.DI_received = this.csbForm_source_location;
            }
        },
        csbForm_quantity(val) {
            if (val !== null) {
                if (typeof val === 'string') {
                    this.csbForm_quantity = parseInt(val);
                } else {
                    if (parseInt(val) >= parseInt(this.csbForm_total_expense)) {
                        this.re_csbForm_quantity(val);
                        if (val > 100000000) {
                            this.error_Over_quantity = true;
                        } else {
                            this.error_Over_quantity = false;
                        }
                    } else {
                        this.csbForm_remaining_balance = 0;
                    }
                }
            } else {
                this.csbForm_quantity = 0;
            }
        },
        DI_count(val) {
            if (val !== null) {
                if (typeof val === 'string') {
                    this.DI_count = parseInt(val);
                }
            } else {
                this.DI_count = 0;
            }
        },
        donatedItems_data(val) {
            // console.log("val",val)
            if (val.length !== 0) {
                for (let index = 0; index < val.length; index++) {
                    const element = val[index];
                    element['index'] = index + 1;
                }
                this.re_csbForm_quantity(this.csbForm_quantity);
                this.re_csb_cal(this.donatedItems_data);
                this.calTotal_expense(this.csb_cal);
            } else {
                this.csb_cal = [];
            }
        },
        computedTotal(newTotal) {
            this.total = newTotal;
        }
    },
    computed: {
        computedTotal() {
            return this.csbForm_remaining_balance - this.DI_count;
        }
    },
    created() {
        // Doe โหลด โทรศัพท์
        // Doe width 2/4
        window.addEventListener('resize', this.handleResize);
        this.handleResize();

        if (this.window.width > 430) {
            this.ms = true;
            this.initialData();
        }
        // Doe โหลด โทรศัพท์

        // Doe PDF เลือกได้  4/5
        this.columnsSelector = this.columns;
        this.PDF_BodySizeSelect = this.PDF_BodySize;
        this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor;

        for (let index = 0; index < this.columnsSelector.length; index++) {
            this.GetData_ColumnsSearch.push(this.columnsSelector[index].dataKey);
        }
        // Doe PDF เลือกได้  4/5  จบ

        // this.initialData();
        this.checkRole = this.decodeJWT(localStorage.getItem('token')).permission_id;
        this.checkView_data = this.decodeJWT(localStorage.getItem('token')).view_data;
        this.checkAdd_data = this.decodeJWT(localStorage.getItem('token')).add_data;
        this.checkEdit_data = this.decodeJWT(localStorage.getItem('token')).edit_data;
        this.checkDelete_data = this.decodeJWT(localStorage.getItem('token')).delete_data;
        // console.log(`checkRole = ${this.checkRole} `);
        // console.log(`checkView_data = ${this.checkView_data} `);
        // console.log(`checkAdd_data = ${this.checkAdd_data} `);
        // console.log(`checkEdit_data = ${this.checkEdit_data} `);
        // console.log(`checkDelete_data = ${this.checkDelete_data} `);

        this.Clone_Data_text_Footer = this.setCloneData(this.Data_text_Footer);
    },

    // Doe โหลด โทรศัพท์
    // Doe width 3/4
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },

    // Doe โหลด โทรศัพท์
    methods: {
        async updateDates() {
            try {
                this.loadingCreate = true;
                const userOrg = this.getUserOrganize();
                const userId = this.getUsername();

                // Format selected records
                const formattedRecords = this.selectedConsumables.map((item) => ({
                    consumables_id: item.consumables_id,
                    ...item
                }));

                // console.log('formattedRecords', formattedRecords);

                const response = await this.axios.post(`${this.$url_service}/initial/consumables?user=${userId}`, {
                    body: {
                        topic: 'edit-consumables_date_multiple',
                        selectedConsumables: formattedRecords,
                        userOrg: userOrg
                    }
                });

                // Check if response exists and has data
                if (response && response.data) {
                    if (response.data.success) {
                        this.loadingCreate = false;
                        this.tempFor_displayConfirmationCloseModal = 'add';
                        this.consumables_TableModal = false;

                        await this.$fire({
                            type: 'success',
                            title: 'ปรับปรุงข้อมูล',
                            text: `อัปเดตข้อมูลเครื่องอุปโภคบริโภคจำนวน ${response.data.updatedIds?.length || 0} รายการ`,
                            timer: 3000,
                            confirmButtonColor: '#28B463'
                        });

                        // Refresh data after successful update
                        await this.searchConsumables();
                    } else {
                        throw new Error(response.data.message || 'ไม่สามารถอัปเดตข้อมูลได้');
                    }
                }
            } catch (error) {
                this.loadingCreate = false;
                await this.$fire({
                    type: 'error',
                    title: 'เกิดข้อผิดพลาด',
                    text: error.response?.data?.message || error.message || 'ไม่สามารถอัปเดตข้อมูลได้',
                    timer: 3000,
                    confirmButtonColor: '#DC3545'
                });
            } finally {
                this.loadingCreate = false;
            }
        },

        onSelectAll(checked) {
            if (checked) {
                this.selectedConsumables = [...this.consumables_Table];
            } else {
                this.selectedConsumables = [];
            }
            this.$emit('selectedConsumables', this.selectedConsumables);
            // console.log('selectedConsumables', this.selectedConsumables);
        },

        onSelectRow(row, checked) {
            if (checked) {
                if (!this.selectedConsumables.some((item) => item.consumables_id === row.consumables_id)) {
                    this.selectedConsumables.push(row);
                }
            } else {
                this.selectedConsumables = this.selectedConsumables.filter((item) => item.consumables_id !== row.consumables_id);
            }
            this.$emit('selectedConsumables', this.selectedConsumables);
            // console.log('selectedConsumables', this.selectedConsumables);
        },

        decodeJWT(token) {
            try {
                const payload = token.split('.')[1];
                // Replace Base64URL to Base64
                const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
                // Decode Base64
                const decodedPayload = atob(base64);
                // Handle UTF-8 encoding and return the parsed JSON object
                const jsonPayload = decodeURIComponent(
                    decodedPayload
                        .split('')
                        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                        .join('')
                );
                return JSON.parse(jsonPayload);
            } catch (error) {
                console.error('Failed to decode JWT token:', error);
                return null;
            }
        },

        saveData_Modal(ModalName) {
            if (ModalName === 'search') {
                if (
                    !this.isFocused('TextBox_1_search') &&
                    !this.isFocused('TextBox_4_search') &&
                    !this.isFocused('TextBox_5_search') &&
                    !this.isFocused('TextBox_7_search') &&
                    !this.isFocused('TextBox_8_search')
                ) {
                    this.searchConsumables();
                }
            } else if (ModalName === 'Modal_Main') {
                if (
                    this.donatedItems_Modal === false &&
                    !this.isFocused('TextBox_5') &&
                    !this.isFocused('TextBox_6') &&
                    !this.isFocused('TextBox_7') &&
                    !this.isFocused('TextBox_8') &&
                    !this.isFocused('TextBox_9') &&
                    !this.isFocused('TextBox_10') &&
                    !this.isFocused('TextBox_13') &&
                    !this.isFocused('TextBox_14') &&
                    !this.isFocused('TextBox_15') &&
                    !this.isFocused('TextBox_16')
                ) {
                    this.saveData();
                }
            } else if (ModalName === 'Modal_DI') {
                if (
                    !this.isFocused('TextBox_1_DI') &&
                    !this.isFocused('TextBox_2_DI') &&
                    !this.isFocused('TextBox_4_DI') &&
                    !this.isFocused('TextBox_5_DI')
                ) {
                    this.saveDonatedItems();
                }
            }
        },
        exportFile(type, fn, dl) {
            const elt = document.getElementById('tbl_DI');
            const wb = XLSX.utils.table_to_book(elt, { sheet: 'sheet1' });
            return dl
                ? XLSX.write(wb, { bookType: type, bookSST: true, type: 'base64' })
                : XLSX.writeFile(wb, fn || `บัญชีจ่ายสิ่งของบริจาค-${this.date}.` + (type || 'xlsx'));
        },
        exportCSV(val) {
            debugger;
            if (val === 'dt') {
                this.$refs.dt.exportCSV();
            } else {
                this.$refs.dt_DI.exportCSV();
            }
        },
        // Doe โหลด โทรศัพท์
        // Doe width 4/4
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;

            this.table_BOXmanege = window.innerWidth > 700 ? 'p-field p-col' : '';
            this.table_editBTN = window.innerWidth > 700 ? this.$i18n.t('editBtn') : '';
            this.table_deleteBTN = window.innerWidth > 700 ? this.$i18n.t('deleteBtn') : '';
            this.table_loadBTN = window.innerWidth > 700 ? 'ส่งออก' : '';
            if (window.innerWidth > 700) {
                this.table_headerStyle = this.checkInnerWidth('15rem', 'Column');
                this.table_bodyStyle = this.checkInnerWidth('15rem', 'Body');
            } else {
                this.table_headerStyle = this.checkInnerWidth('105px', 'Column');
                this.table_bodyStyle = this.checkInnerWidth('105px', 'Body');
            }
        },
        // Doe โหลด โทรศัพท์

        // Doe ค้นหา  3/6
        async search() {
            // this.ms = true
            if (this.filter != '' && this.consumables_Table !== []) {
                this.consumables_Table = this.cloneTable.filter((item) => {
                    return (
                        (this.columns_date_received ? item.date_received.includes(this.filter) : '') ||
                        (this.columns_item_name ? item.item_name.includes(this.filter) : '') ||
                        (this.columns_quantity ? item.quantity.includes(this.filter) : '') ||
                        (this.columns_total_expense ? item.total_expense.includes(this.filter) : '') ||
                        (this.columns_remaining_balance ? item.remaining_balance.includes(this.filter) : '') ||
                        (this.columns_unit ? item.unit.includes(this.filter) : '') ||
                        (this.columns_date_expiration ? item.date_expiration.includes(this.filter) : '') ||
                        (this.columns_storage_location ? item.storage_location.includes(this.filter) : '') ||
                        (this.columns_lat ? item.organize_lat.includes(this.filter) : '') ||
                        (this.columns_lon ? item.organize_lon.includes(this.filter) : '') ||
                        (this.columns_source_type ? item.source_type.includes(this.filter) : '') ||
                        (this.columns_consumables_code ? item.consumables_code.includes(this.filter) : '') ||
                        (this.columns_organize_name ? item.organize_name.includes(this.filter) : '') ||
                        (this.columns_source_location ? item.source_location.includes(this.filter) : '') ||
                        (this.columns_date_create_consumables ? item.date_create_consumables.includes(this.filter) : '') ||
                        (this.columns_date_update_consumables ? item.date_update_consumables.includes(this.filter) : '') ||
                        (this.columns_editor ? item.editor.includes(this.filter) : '')
                    );
                });

                for (let i = 0; i < this.consumables_Table.length; i++) {
                    this.consumables_Table[i]['index'] = i + 1;
                }
                return this.consumables_Table;
            } else {
                this.consumables_Table = this.cloneTable;
                for (let i = 0; i < this.consumables_Table.length; i++) {
                    this.consumables_Table[i]['index'] = i + 1;
                }
            }

            this.consumables_Table = this.cloneTable;
        },
        // Doe ค้นหา  3/6 จบ

        async initialData() {
            const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์
            this.ms = true;
            this.filter = '';
            this.cloneTable = [];
            this.loading = true;
            await this.axios
                .post(`${this.$url_service}/get/datagroup`, {
                    body: { topic: 'get-option-maingroup', datagroup: 'dg-09' }
                })
                .then((response) => (this.unitNameOptions = response.data.data));
            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-23' }
                })
                .then((response) => {
                    this.standard_nameOptions = response.data.data;
                    // this.standard_nameOptions.splice(0, 0, {
                    //   system_name: this.$i18n.t("selectAll"),
                    // });
                    // console.log('this.standard_nameOptions = ',this.standard_nameOptions)
                });
            //     const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์

            await this.axios
                .post(`${this.$url_service}/initial/consumables`, {
                    body: {
                        topic: 'get-table'
                        // userOrg,
                    }
                })
                // Doe : เพิ่ม ลำดับ 3/4
                .then((response) => {
                    // console.log(response.data.data)
                    this.consumables_Table = response.data.data;
                    this.cloneTable = response.data.data;

                    this.csb_formatData(this.consumables_Table);
                });
            // Doe : เพิ่ม ลำดับ 3/4 จบ

            this.loading = false;
        },

        csb_formatData(data) {
            // console.log(data)
            for (let i = 0; i < data.length; i++) {
                const element = data[i];
                element['index'] = i + 1;

                // จำนวน
                if (element.quantity) {
                    element.quantity = parseInt(element.quantity).toLocaleString('en');
                }
                // จ่ายออก
                if (element.total_expense) {
                    element.total_expense = parseInt(element.total_expense).toLocaleString('en');
                }
                // ยอดคงเหลือ
                if (element.remaining_balance) {
                    element.remaining_balance = parseInt(element.remaining_balance).toLocaleString('en');
                }

                // เลขทะเบียนทรัพย์สิน
                if (element.consumables_code == '') {
                    element.consumables_code = '-';
                }

                // วันที่ได้รับ
                if (element.date_received !== '') {
                    const date_received = element.date_received.split('/');
                    const date_received_dateNew = new Date(`${date_received[2]}/${date_received[1]}/${date_received[0]}`);
                    element.date_received = this.changeDateToThai(date_received_dateNew);
                } else {
                    element.date_received = '-';
                }

                // วันที่หมดอายุ
                if (element.date_expiration !== '') {
                    const date_expiration = element.date_expiration.split('/');
                    const date_expiration_dateNew = new Date(`${date_expiration[2]}/${date_expiration[1]}/${date_expiration[0]}`);
                    element.date_expiration = this.changeDateToThai(date_expiration_dateNew);
                } else {
                    element.date_expiration = '-';
                }

                // แหล่งที่มา
                if (element.source_location == '') {
                    element.source_location = '-';
                }

                // วันที่สร้างข้อมูล
                if (element.date_create_consumables !== '') {
                    const date_create = element.date_create_consumables.split('/');
                    const date_create_dateNew = new Date(`${date_create[2]}/${date_create[1]}/${date_create[0]}`);
                    element.date_create_consumables = this.changeDateToThai(date_create_dateNew);
                }

                // วันที่ปรับปรุง
                if (element.date_update_consumables !== '') {
                    const date_update = element.date_update_consumables.split('/');
                    const date_update_dateNew = new Date(`${date_update[2]}/${date_update[1]}/${date_update[0]}`);
                    element.date_update_consumables = this.changeDateToThai(date_update_dateNew);
                }
            }
            // console.log("data",data)
        },
        acceptNumber() {
            const x = this.csbForm_quantity.replace(/\D/g, '');
            this.csbForm_quantity = x.substring(0, 6);
        },
        acceptNumber2() {
            const x = this.DI_count.replace(/\D/g, '');
            this.DI_count = x.substring(0, 6);
        },

        clearImage() {
            this.url = null;
            this.pic = '';
            document.getElementById('csb_uploadImageFile').value = '';
        },

        onFileChange(e) {
            // const imgSize = this.$refs.file.files[0];

            document.getElementById('csb_uploadImageFile').click();
            if (e.type !== 'click') {
                if (e.target.files[0] != undefined) {
                    // const imgSize = e.target.files[0]
                    // if (imgSize.size > 7340032) {
                    //   this.$fire({
                    //         type: "warning",
                    //         title:"ขนาดไฟล์ใหญ่เกินไป",
                    //         text: "กรุณาใส่เฉพาะไฟล์รูปภาพไม่เกิน 7 MB.",
                    //         timer: 3000,
                    //         confirmButtonColor: '#28B463',
                    //       });
                    //       this.clearImage()

                    // }else {
                    if (e.target.files[0].type.split('/')[0] == 'image') {
                        this.pic = '';
                        const file = e.target.files[0];
                        this.url = URL.createObjectURL(file);

                        var reader = new FileReader();

                        reader.onload = (e) => {
                            var img = document.createElement('img');
                            img.onload = () => {
                                var canvas = document.createElement('canvas');
                                var ctx = canvas.getContext('2d');
                                ctx.drawImage(img, 0, 0);

                                var MAX_WIDTH = 250;
                                var MAX_HEIGHT = 250;
                                var width = img.width;
                                var height = img.height;

                                if (width > height) {
                                    if (width > MAX_WIDTH) {
                                        height *= MAX_WIDTH / width;
                                        width = MAX_WIDTH;
                                    }
                                } else {
                                    if (height > MAX_HEIGHT) {
                                        width *= MAX_HEIGHT / height;
                                        height = MAX_HEIGHT;
                                    }
                                }
                                canvas.width = width;
                                canvas.height = height;
                                ctx = canvas.getContext('2d');
                                ctx.drawImage(img, 0, 0, width, height);

                                var dataurl = canvas.toDataURL('image/png');
                                let console = {};
                                let logger = document.getElementById('csb_image');
                                console.log = (text) => {
                                    let txt = document.createTextNode(text);
                                    logger.appendChild(txt);
                                };
                                // console.log(dataurl);
                            };
                            img.src = e.target.result;
                        };
                        reader.readAsDataURL(file);
                        this.pic = e.target.files[0].name;
                    } else {
                        this.$fire({
                            type: 'error',
                            title: 'ประเภทไฟล์ผิดพลาด',
                            text: 'กรุณาใส่เฉพาะไฟล์รูปภาพเท่านั้น',
                            timer: 3000,
                            confirmButtonColor: '#28B463'
                        });
                        this.url = null;
                        document.getElementById('csb_uploadImageFile').value = '';
                        this.pic = '';
                    }
                }
                // } else {
                //   this.pic = ""
                //   this.url = null;
                // }
            }
        },

        selectedOrganize_passValue_Form(variable) {
            this.showOrganize_Form = false;
            if (this.consumables_TableModal == false) {
                this.selectedOrganize = {
                    id: variable.organize_id,
                    name: variable.organize_name
                };
                if (this.setOpenModal_Organize === 'search') {
                    this.csb_storage_location = {
                        id: variable.organize_id,
                        name: variable.organize_name
                    };
                }
            } else {
                if (this.setOpenModal_Organize === '') {
                    this.iev_organize = {
                        id: variable.organize_id,
                        name: variable.organize_name
                    };
                } else if (this.setOpenModal_Organize === 'storage') {
                    this.csbForm_storage_location = {
                        id: variable.organize_id,
                        name: variable.organize_name
                    };
                } else if (this.setOpenModal_Organize === 'give') {
                    this.DI_give = {
                        id: variable.organize_id,
                        name: variable.organize_name
                    };
                }
            }
        },
        checkSelectedOrganize(status) {
            if (status !== '') {
                return true;
            } else {
                return false;
            }
        },
        selectedOrganize_passValue(variable) {
            this.showOrganize = false;
            if (variable != null) {
                if (this.setOpenModal_OrganizeMulti === 'search') {
                    this.organize_table = [];
                    for (let i = 0; i < variable.length; i++) {
                        this.organize_table.push({
                            organize_id: variable[i].organize_id,
                            organize_name: variable[i].organize_name
                        });
                    }
                }
            }
        },

        async searchConsumables() {
            if (!this.checkToken()) {
                return;
            }

            // console.log('this.checkToken() = ', this.checkToken());

            this.ms = true;
            // this.filter='';
            this.cloneTable = [];
            this.loading = true;

            var userSelectedOrganize = JSON.stringify(this.selectedOrganize);
            if (userSelectedOrganize != '{}') {
                userSelectedOrganize = JSON.parse(userSelectedOrganize).id;
            } else {
                userSelectedOrganize = this.selectedOrganize;
            }

            // console.log('this.getUserOrganize()', this.getUserOrganize());
            // console.log('this.checkPermission()', this.getUserOrganize());
            // console.log("this.checkDate_showEN(this.csb_receivedDate)",this.checkDate_showEN(this.csb_receivedDate))
            await this.axios
                .post(`${this.$url_service}/initial/consumables`, {
                    body: {
                        topic: 'search-table',
                        consumables_code: this.csb_consumables_code,
                        location_id: '',
                        item_name: this.csb_itemName,
                        unit: '',
                        quantity: '',
                        total_expense: '',
                        remaining_balance: '',
                        date_received: this.csb_receivedDate === null ? '' : this.checkDate_showEN(this.csb_receivedDate),
                        date_expiration: this.csb_expirationDate === null ? '' : this.checkDate_showEN(this.csb_expirationDate),
                        source_type: this.csb_sourceType_Selector === null ? '' : this.csb_sourceType_Selector,
                        source_location: this.csb_source_location,
                        storage_location: this.csb_storage_location.name === undefined ? '' : this.csb_storage_location.name,
                        lat: '',
                        lon: '',
                        organize: this.organize_table,
                        // userOrg:"",
                        detail_expense: ''
                    }
                })
                // Doe : เพิ่ม ลำดับ 4/4
                .then((response) => {
                    this.consumables_Table = response.data.data;
                    // Doe ค้นหา  4/6
                    this.cloneTable = response.data.data;
                    // Doe ค้นหา  4/6

                    this.csb_formatData(this.consumables_Table);

                    this.setSearchText_Footer();
                });
            // Doe : เพิ่ม ลำดับ 4/4 จบ

            this.search();
            this.loading = false;
        },
        setSearchText_Footer() {
            this.text_Footer = false;
            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);

            if (
                this.organize_table.length !== 0 ||
                this.csb_itemName !== '' ||
                this.csb_sourceType_Selector !== null ||
                this.csb_source_location !== '' ||
                this.csb_storage_location.name !== undefined ||
                // this.csb_receivedDate !== null ||
                // this.csb_expirationDate !== null ||
                this.checkDateNull_String(this.csb_receivedDate) ||
                this.checkDateNull_String(this.csb_expirationDate) ||
                this.csb_consumables_code !== ''
            ) {
                for (let index = 0; index < this.Data_text_Footer.length; index++) {
                    const element = this.Data_text_Footer[index];
                    if (element.DataName === 'หน่วยงานที่รับผิดชอบ' && this.organize_table.length !== 0) {
                        element.textShow = this.setAll_organize_table(this.organize_table);
                    }
                    if (element.DataName === 'รายการ' && this.csb_itemName !== '') {
                        element.textShow = this.csb_itemName;
                    }
                    if (element.DataName === 'ประเภทที่มา' && this.csb_sourceType_Selector !== null) {
                        element.textShow = this.csb_sourceType_Selector;
                    }
                    if (element.DataName === 'แหล่งที่มา' && this.csb_source_location !== '') {
                        element.textShow = this.csb_source_location;
                    }
                    if (element.DataName === 'สถานที่จัดเก็บ' && this.csb_storage_location.name !== undefined) {
                        element.textShow = this.csb_storage_location.name;
                    }
                    if (element.DataName === 'วันที่ได้รับ' && this.csb_receivedDate !== null && this.csb_receivedDate !== '') {
                        element.textShow = this.checkInvalid_Date(this.changeDateToThai(this.checkDate(this.csb_receivedDate)), 'string');
                    }
                    if (element.DataName === 'วันหมดอายุ' && this.csb_expirationDate !== null && this.csb_expirationDate !== '') {
                        element.textShow = this.checkInvalid_Date(this.changeDateToThai(this.checkDate(this.csb_expirationDate)), 'string');
                    }
                    if (element.DataName === 'เลขทะเบียนทรัพย์สิน' && this.csb_consumables_code !== '') {
                        element.textShow = this.csb_consumables_code;
                    }
                }

                this.text_Footer = true;
            }
            // console.log("this.Clone_Data_text_Footer",this.Clone_Data_text_Footer)
            // console.log("this.Data_text_Footer",this.Data_text_Footer)
        },
        setAll_organize_table(data) {
            let text = [];
            for (let index = 0; index < data.length; index++) {
                const element = data[index];
                if (element.organize_name !== undefined) {
                    text += element.organize_name + ',';
                }
            }
            return text.slice(0, -1);
        },
        checkDateNull_String(info) {
            if (typeof info === 'object' && info !== null) {
                return true;
            } else {
                if (info !== null && info !== '' && info.length === 10) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        async confirmDelete() {
            if (!this.checkToken()) {
                return;
            }

            // console.log('this.checkToken() = ', this.checkToken());

            if (this.deleteAt == 'donatedItems-table') {
                this.donatedItems_data = this.donatedItems_data.filter((val) => val !== this.deleteDonatedItems);
                this.csbForm_total_expense -= parseInt(this.deleteDonatedItems.num_expense);
                this.csbForm_remaining_balance += parseInt(this.deleteDonatedItems.num_expense);
                this.re_csbForm_quantity(this.csbForm_quantity);
                this.reDate_received(this.csbForm_date_received);
                this.re_csb_cal(this.donatedItems_data);

                this.displayConfirmation = false;
            } else if (this.deleteAt == 'organize') {
                this.displayConfirmation = false;
                this.organize_table = this.organize_table.filter((val) => val !== this.organizeDelete);
            } else {
                const userId = this.getUsername();
                await this.axios
                    .post(`${this.$url_service}/initial/consumables?user=${userId}`, {
                        body: {
                            topic: 'delete',
                            id: this.temp
                        }
                    })
                    .then(() =>
                        // this.initialData()
                        this.searchConsumables()
                    );
                this.displayConfirmation = false;
                // this.$toast.add({
                //   severity: "success",
                //   summary: "ลบข้อมูลสำเร็จ",
                //   detail: "ข้อมูลเครื่องมือ",
                //   life: 3000,
                // });
                this.$fire({
                    type: 'success',
                    title: 'ลบข้อมูลสำเร็จ',
                    text: 'ข้อมูลเครื่องมือ',
                    timer: 3000,
                    confirmButtonColor: '#28B463'
                });
            }
        },
        setSaveData_date(date, type) {
            if (date !== null && date !== '') {
                return this.changeDateToEN(date);
            } else if (type === 'string') {
                return '';
            } else {
                return null;
            }
        },
        async saveData() {
            if (!this.checkToken()) {
                return;
            }

            // console.log('this.checkToken() = ', this.checkToken());

            // console.log("setSaveData_date",this.setSaveData_date(this.csbForm_date_expiration,"string"))
            if (
                this.csbForm_itemName == '' ||
                this.iev_organize.name == undefined ||
                this.csbForm_quantity == '' ||
                this.csbForm_quantity == 0 ||
                this.error_Over_quantity == true ||
                this.Maintenance_unit == null ||
                this.csbForm_source_type == null ||
                this.csbForm_storage_location.name == null ||
                this.iie_selectedProvince == null ||
                this.iie_selectedAmphur == null ||
                this.iie_selectedTambon == null ||
                this.iie_lat == '' ||
                this.iie_lon == '' ||
                parseInt(this.csbForm_quantity) < parseInt(this.csbForm_total_expense) ||
                this.csbForm_date_received == null ||
                typeof this.csbForm_date_received !== 'object' ||
                this.csbForm_source_location == '' ||
                this.check_date_received
            ) {
                if (this.csbForm_itemName == '') {
                    this.error_csbForm_itemName = true;
                }
                if (this.iev_organize.name == undefined) {
                    this.error_iev_organize = true;
                }
                if (this.csbForm_quantity == '' || this.csbForm_quantity == 0) {
                    this.error_csbForm_quantity = true;
                }
                if (this.Maintenance_unit == null) {
                    this.error_csbForm_Maintenance_unit = true;
                }
                if (this.csbForm_source_type == null) {
                    this.error_csbForm_source_type = true;
                }
                if (this.csbForm_storage_location.name == undefined) {
                    this.error_csbForm_storage_location = true;
                }
                if (this.iie_selectedProvince == null) {
                    this.error_iie_selectedProvince = true;
                }
                if (this.iie_selectedAmphur == null) {
                    this.error_iie_selectedAmphur = true;
                }
                if (this.iie_selectedTambon == null) {
                    this.error_iie_selectedTambon = true;
                }
                if (this.iie_lat == '') {
                    this.error_iie_lat = true;
                }
                if (this.iie_lon == '') {
                    this.error_iie_lon = true;
                }
                if (this.csbForm_date_received == null || typeof this.csbForm_date_received !== 'object') {
                    this.error_csbForm_date_received = true;
                }
                if (this.csbForm_source_location == '') {
                    this.error_csbForm_source_location = true;
                }
            } else {
                if (this.selectedData == '') {
                    // โหลดเพิ่มแก้ไข 4/8
                    this.loadingCreate = true;
                    // โหลดเพิ่มแก้ไข 4/8 จบ

                    const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์
                    const userId = this.getUsername();

                    await this.axios
                        .post(`${this.$url_service}/initial/consumables?user=${userId}`, {
                            body: {
                                topic: 'add',
                                userOrg,
                                // user_organize:this.getUserOrganize(),
                                consumables_code: this.csbForm_consumables_code,
                                location_id: {
                                    tambon_id: this.iie_selectedTambon.tambon_id
                                },
                                item_name: this.csbForm_itemName,
                                unit: this.Maintenance_unit.system_name,
                                quantity: parseInt(this.csbForm_quantity),
                                total_expense: parseInt(this.csbForm_total_expense),
                                remaining_balance: parseInt(this.csbForm_remaining_balance),
                                date_received: this.setSaveData_date(this.csbForm_date_received, 'string'),
                                date_expiration: this.setSaveData_date(this.csbForm_date_expiration, 'string'),
                                source_type: this.csbForm_source_type,
                                source_location: this.csbForm_source_location,
                                storage_location: this.csbForm_storage_location.name,
                                lat: this.iie_lat,
                                lon: this.iie_lon,
                                detail_expense: this.donatedItems_data,
                                image: this.$refs.csb_image.innerText,
                                organize: this.iev_organize.id,
                                editor: this.decodeJWT.user_id
                            }
                        })
                        .then(() =>
                            // this.initialData()
                            this.searchConsumables()
                        );
                    // โหลดเพิ่มแก้ไข 5/8
                    this.loadingCreate = false;
                    // โหลดเพิ่มแก้ไข 5/8 จบ

                    this.$fire({
                        type: 'success',
                        title: 'เพิ่มข้อมูลสำเร็จ',
                        text: 'เครื่องอุปโภค บริโภค',
                        timer: 3000,
                        confirmButtonColor: '#28B463'
                    });
                    this.tempFor_displayConfirmationCloseModal = 'add';
                    this.consumables_TableModal = false;
                } else {
                    if (this.$refs.csb_image.innerText == '') {
                        this.$refs.csb_image.innerText = this.url;
                    } else {
                        this.$refs.csb_image.innerText = this.$refs.csb_image.innerText;
                    }
                    // โหลดเพิ่มแก้ไข 6/8 จบ
                    this.loadingCreate = true;
                    // โหลดเพิ่มแก้ไข 6/8 จบ
                    // console.log("this.MaintenanceHistory",this.MaintenanceHistory)
                    const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์
                    const userId = this.getUsername();
                    await this.axios
                        .post(`${this.$url_service}/initial/consumables?user=${userId}`, {
                            body: {
                                topic: 'edit',
                                id: this.temp,
                                userOrg,
                                // user_organize:this.getUserOrganize(),
                                consumables_code: this.csbForm_consumables_code,
                                location_id: {
                                    tambon_id: this.iie_selectedTambon.tambon_id
                                },
                                item_name: this.csbForm_itemName,
                                unit: this.Maintenance_unit.system_name,
                                quantity: parseInt(this.csbForm_quantity),
                                total_expense: parseInt(this.csbForm_total_expense),
                                remaining_balance: parseInt(this.csbForm_remaining_balance),
                                date_received: this.setSaveData_date(this.csbForm_date_received, 'string'),
                                date_expiration: this.setSaveData_date(this.csbForm_date_expiration, 'string'),
                                source_type: this.csbForm_source_type,
                                source_location: this.csbForm_source_location,
                                storage_location: this.csbForm_storage_location.name,
                                lat: this.iie_lat,
                                lon: this.iie_lon,
                                detail_expense: this.donatedItems_data,
                                image: this.$refs.csb_image.innerText,
                                organize: this.iev_organize.id,
                                editor: this.decodeJWT.user_id
                            }
                        })
                        .then(() =>
                            // this.initialData()
                            this.searchConsumables()
                        );
                    // โหลดเพิ่มแก้ไข 7/8 จบ
                    this.loadingCreate = false;
                    // โหลดเพิ่มแก้ไข 7/8 จบ

                    this.$fire({
                        type: 'success',
                        title: 'แก้ไขข้อมูลสำเร็จ',
                        text: 'ข้อมูลเครื่องอุปโภค บริโภค',
                        timer: 3000,
                        confirmButtonColor: '#28B463'
                    });
                    this.consumables_TableModal = false;
                }
            }
        },

        async editData(data) {
            if (!this.checkToken()) {
                return;
            }

            // console.log('this.checkToken() = ', this.checkToken());

            this.header = 'แก้ไขข้อมูล เครื่องอุปโภค บริโภค';
            await this.axios
                .post(`${this.$url_service}/initial/consumables`, {
                    body: {
                        topic: 'showone',
                        id: data
                    }
                })
                .then((response) => {
                    this.selectedData = response.data.data;
                    // console.log("this.selectedData",this.selectedData)
                    this.csbForm_itemName = response.data.data.item_name;
                    this.csbForm_consumables_code = response.data.data.consumables_code;

                    // this.csbForm_quantity = response.data.data.quantity
                    // this.csbForm_total_expense = response.data.data.total_expense
                    // this.csbForm_remaining_balance = response.data.data.remaining_balance

                    this.csbForm_quantity = parseInt(response.data.data.quantity);
                    this.csbForm_total_expense = parseInt(response.data.data.total_expense);
                    this.csbForm_remaining_balance = parseInt(response.data.data.remaining_balance);

                    this.Maintenance_unit = { system_name: response.data.data.unit };
                    this.csbForm_source_type = response.data.data.source_type;
                    this.csbForm_date_received = this.changePositionDate_MaxMin(response.data.data.date_received, 'null');
                    this.csbForm_date_expiration = this.changePositionDate_MaxMin(response.data.data.date_expiration, 'null');

                    this.csbForm_source_location = response.data.data.source_location;
                    this.iev_organize = {
                        id: response.data.data.organize_id,
                        name: response.data.data.organize_name
                    };
                    this.url = response.data.data.image;

                    this.csbForm_storage_location = { name: response.data.data.storage_location };
                    this.csbForm_date_create = response.data.data.date_create_consumables;
                    this.csbForm_date_update = response.data.data.date_update_consumables;

                    this.iie_selectedProvince = response.data.data.province_name;
                    this.iie_selectedAmphur = response.data.data.amphur_name;
                    this.iie_selectedTambon = response.data.data.tambon_name;

                    this.iie_lat = response.data.data.event_lat;
                    this.iie_lon = response.data.data.event_lon;

                    this.donatedItems_data = JSON.parse(response.data.data.detail_expense);

                    // console.log("this.donatedItems_data",this.donatedItems_data)

                    // Doe เพิ่มหมุด map V.2 7/9
                    if (this.iie_lat !== '' && this.iie_lat !== null && this.iie_lon !== '' && this.iie_lon !== null) {
                        this.inputMap_latlon();
                    } else {
                        this.inputMap_PAT_latlon();
                    }
                    // Doe เพิ่มหมุด map V.2 7/9  จบ
                });
        },
        setExport_DI(modal, detail, item_name, quantity) {
            if (modal) {
                this.modalExport_Form = modal;
                this.donatedItems_data = detail;
                this.csbForm_itemName = item_name;

                if (typeof quantity === 'string') {
                    const sp_quantity = quantity.split(',');
                    let sum = sp_quantity.reduce(function (total, currentValue) {
                        return total + currentValue;
                    });
                    this.csbForm_quantity = parseInt(sum);
                } else {
                    this.csbForm_quantity = quantity;
                }
            } else {
                this.modalExport_Form = modal;
            }
        },
        checkTotal_expense() {
            if (this.DI_count !== '' || this.DI_count !== 0) {
                if (parseInt(this.DI_count) <= parseInt(this.csbForm_remaining_balance)) {
                    return true;
                } else {
                    const setText = `กรุณาระบุ ข้อมูลจำนวน น้อยกว่า ข้อมูลยอดของคงเหลือ`;
                    this.$fire({
                        title: 'กรุณาระบุข้อมูล',
                        text: setText,
                        type: 'warning',
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'ตกลง',
                        timer: 3500
                    });
                    return false;
                }
            }
        },
        calTotal_expense(val) {
            if (val.length !== 0) {
                let sum = val.reduce(function (total, currentValue) {
                    return total + currentValue;
                }, 0);
                this.csbForm_total_expense = sum;
                this.csbForm_remaining_balance = parseInt(this.csbForm_quantity) - sum;
                // console.log("this.csbForm_remaining_balance---",this.csbForm_remaining_balance);
                // console.log("sum---",sum);
                return this.csbForm_remaining_balance;
            } else {
                return (this.csbForm_remaining_balance = parseInt(this.csbForm_quantity));
            }
        },
        setOpen_donatedItems_Modal(id) {
            if (this.donatedItems_Modal === false) {
                if (this.Maintenance_unit === null || this.csbForm_quantity === '' || this.csbForm_quantity === 0) {
                    if (this.Maintenance_unit === null) {
                        this.error_csbForm_Maintenance_unit = true;
                    }
                    if (this.csbForm_quantity === '' || this.csbForm_quantity === 0) {
                        this.error_csbForm_quantity = true;
                    }

                    const setAnd = this.Maintenance_unit === null && this.csbForm_quantity === 0 ? `และ` : '';
                    const setText = `กรุณาระบุ ${this.Maintenance_unit === null ? 'หน่วยนับ' : ''} ${setAnd} ${
                        this.csbForm_quantity === 0 || this.csbForm_quantity === '' ? 'จำนวน' : ''
                    }`;
                    this.$fire({
                        title: 'กรุณาระบุข้อมูล',
                        text: setText,
                        type: 'warning',
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'ตกลง',
                        timer: 3000
                    });
                } else {
                    if (id === '') {
                        this.header_DI = 'เพิ่มข้อมูล บัญชีจ่ายสิ่งของบริจาค';
                        this.donatedItems_Modal = true;
                    } else {
                        this.setDonatedItems(id);
                        this.donatedItems_Modal = true;
                    }
                }
            }
        },

        async saveDonatedItems() {
            if (
                this.DI_date == null ||
                this.DI_date == '' ||
                this.DI_received === '' ||
                this.DI_give.name == null ||
                this.DI_count === '' ||
                this.DI_count === 0
            ) {
                if (this.DI_date == null || this.DI_date == '') {
                    this.error_DI_date = true;
                }
                if (this.DI_received == '') {
                    this.error_DI_received = true;
                }
                if (this.DI_give.name == null) {
                    this.error_DI_give = true;
                }
                if (this.DI_count == '' || this.DI_count === 0) {
                    this.error_DI_count = true;
                }
            } else {
                if (this.checkTotal_expense()) {
                    if (Object.keys(this.dataEdit_DI).length === 0) {
                        let num = this.donatedItems_data.length;
                        let id = '';
                        if (this.donatedItems_data.length === 0) {
                            id = 1;
                        } else {
                            id = parseInt(this.donatedItems_data[num - 1].id_DI) + 1;
                        }
                        this.csb_cal.push(parseInt(this.DI_count));
                        this.donatedItems_data.push({
                            id_DI: id.toString(),
                            date: this.changeDateToEN(this.DI_date),
                            date_ShowTable: this.changeDateToThai(this.DI_date),
                            received_from: this.DI_received,
                            expiration_to: this.DI_give.name,
                            num_expense: this.DI_count,
                            num_remaining: this.calTotal_expense(this.csb_cal),
                            unit: this.Maintenance_unit.system_name
                        });
                        this.re_csbForm_quantity(this.csbForm_quantity);
                        this.reDate_received(this.csbForm_date_received);

                        this.successSaveDonatedItems();

                        this.$fire({
                            title: 'เพิ่มข้อมูลสำเร็จ',
                            text: 'ข้อมูลบัญชีจ่ายสิ่งของบริจาค',
                            type: 'success',
                            confirmButtonColor: '#28B463',
                            timer: 3500
                        });

                        // console.log("this.donatedItems_data",this.donatedItems_data)
                        // console.log("this.csb_cal",this.csb_cal)
                    } else {
                        if (this.checkEdit_DI_count) {
                            this.csb_cal.push(parseInt(this.DI_count));
                            this.calTotal_expense(this.csb_cal);
                            this.checkEdit_DI_count = false;
                        }

                        // const date = this.isDate(this.DI_date) ? this.DI_date : this.changePositionDate_MaxMin(this.DI_date,"null")
                        const date = this.checkDate(this.DI_date, 'null');
                        this.dataEdit_DI[0].date = this.changeDateToEN(this.checkDate(this.DI_date));
                        this.dataEdit_DI[0].date_ShowTable = this.changeDateToThai(date);
                        this.dataEdit_DI[0].received_from = this.DI_received;
                        this.dataEdit_DI[0].expiration_to = this.DI_give.name;
                        this.dataEdit_DI[0].num_expense = this.DI_count;

                        this.re_csbForm_quantity(this.csbForm_quantity);
                        this.reDate_received(this.csbForm_date_received);

                        this.successSaveDonatedItems();

                        this.$fire({
                            title: 'แก้ไขข้อมูลสำเร็จ',
                            text: 'ข้อมูลบัญชีจ่ายสิ่งของบริจาค',
                            type: 'success',
                            confirmButtonColor: '#28B463',
                            timer: 3500
                        });
                        // console.log("this.donatedItems_data2222222",this.donatedItems_data)
                    }
                }
            }
        },
        setDonatedItems(id) {
            this.header_DI = 'แก้ไขข้อมูล บัญชีจ่ายสิ่งของบริจาค';

            this.dataEdit_DI = this.donatedItems_data.filter((val) => {
                return val.id_DI === id;
            });

            let check = true;
            this.csb_cal = this.csb_cal.filter((item) => {
                if (item === parseInt(this.dataEdit_DI[0].num_expense) && check) {
                    check = false;
                    return false;
                }
                return true;
            });
            this.calTotal_expense(this.csb_cal);

            this.DI_date = this.dataEdit_DI[0].date;
            this.DI_received = this.dataEdit_DI[0].received_from;
            this.DI_give = { name: this.dataEdit_DI[0].expiration_to };
            this.DI_count = this.dataEdit_DI[0].num_expense;
        },
        successSaveDonatedItems() {
            // this.clearSubData()
            this.donatedItems_Modal = false;
        },
        re_csbForm_quantity(val) {
            if (this.csbForm_total_expense === 0) {
                this.csbForm_remaining_balance = parseInt(val);
            } else {
                this.csbForm_remaining_balance = parseInt(val) - this.csbForm_total_expense;
            }

            if (this.donatedItems_data.length !== 0) {
                for (let index = 0; index < this.donatedItems_data.length; index++) {
                    const element_c = this.donatedItems_data[index];
                    const element = this.donatedItems_data[index - 1];
                    if (index === 0) {
                        element_c.num_remaining = val - element_c.num_expense;
                    } else {
                        element_c.num_remaining = element.num_remaining - element_c.num_expense;
                    }
                }
            }
        },
        re_csb_cal(data) {
            this.csb_cal = [];
            if (data.length !== 0) {
                for (let index = 0; index < data.length; index++) {
                    const element = data[index];
                    this.csb_cal.push(parseInt(element.num_expense));
                }
            }
        },
        reDate_received(val) {
            this.DataError_date_received = [];
            for (let index = 0; index < this.donatedItems_data.length; index++) {
                const element = this.donatedItems_data[index];
                const date = this.checkDate(element.date, 'null');
                if (val > date) {
                    this.check_date_received = true;
                    this.DataError_date_received.push(this.checkDate_showEN(date));
                } else if (this.DataError_date_received.length === 0) {
                    this.check_date_received = false;
                }
            }
        },
        setDate_csbForm(data) {
            if (Object.keys(data).length !== 0 && this.donatedItems_data.length !== 0) {
                for (let index = 0; index < this.donatedItems_data.length; index++) {
                    const element = this.donatedItems_data[index];
                    if (data[0].index === 1) {
                        return this.csbForm_date_received;
                    } else if (data[0].index === element.index && data[0].index !== 1) {
                        const date = this.donatedItems_data[index - 1].date;
                        const dateNew = this.checkDate(date, 'null');

                        return dateNew;
                    }
                }
            } else if (this.donatedItems_Modal) {
                if (this.donatedItems_data.length !== 0) {
                    const num = this.donatedItems_data.length;
                    const date = this.donatedItems_data[num - 1].date;
                    const dateNew = this.checkDate(date, 'null');
                    return dateNew;
                } else {
                    return this.csbForm_date_received;
                }
            }
        },
        setDateMax_csbForm(data) {
            if (Object.keys(data).length !== 0 && this.donatedItems_data.length !== 0) {
                for (let index = 0; index < this.donatedItems_data.length; index++) {
                    const element = this.donatedItems_data[index];
                    const elementReturn = this.donatedItems_data[index + 1];
                    if (data[0].index === element.index) {
                        if (elementReturn !== undefined) {
                            return this.checkDate(elementReturn.date, 'null');
                        } else {
                            return null;
                        }
                    }
                }
            } else if (this.donatedItems_Modal) {
                return null;
            }
        },
        checkCsbForm_date_received(info) {
            if (info === null || info === '') {
                return true;
            } else {
                return false;
            }
        },
        exportPDF_Form(data) {
            for (let index = 0; index < data.length; index++) {
                const element = data[index];
                element.num_expense = parseInt(element.num_expense).toLocaleString('en');
                element.num_remaining = element.num_remaining.toLocaleString('en');
            }
            return data;
        },
        exportExcel_Form(data) {
            for (let index = 0; index < data.length; index++) {
                const element = data[index];
                element.num_expense = parseInt(element.num_expense).toLocaleString('en');
                element.num_remaining = element.num_remaining.toLocaleString('en');
            }
            return data;
        },
        // this.csbForm_itemName
        exportExcel_Form_Header(info) {
            if (info !== '') {
                return `บัญชีจ่ายสิ่งของบริจาค (${info})`;
            } else {
                return `บัญชีจ่ายสิ่งของบริจาค ()`;
            }
        },
        clearData() {
            // console.log(' use clearData ' );
            this.dropdownClearFilerValue += 1;
            if (this.selectedData != '') {
                // console.log(' this.selectedData != "" ' );
                this.header = 'เพิ่มข้อมูล เครื่องอุปโภค บริโภค';
                this.temp = null;
                this.displayConfirmation = false;
                this.consumables_TableModal = false;
                this.selectedData = '';
                this.setDefault();

                this.deviceTypeSelected = null;
                this.vehicleSelected = null;
                this.iev_equipment_standard_name = null;

                //Add data
            } else {
                // console.log(' this.selectedData == "" ' );
                this.temp = null;
                this.displayConfirmation = false;
                this.setDefault();
            }
        },

        setDefault() {
            document.getElementById('csb_uploadImageFile').value = '';
            this.clear_data();
        },
        clear_data() {
            this.tempFor_displayConfirmationCloseModal = '';
            this.url = null;
            // document.getElementById("csb_uploadImageFile").value = "";
            this.pic = '';

            this.csbForm_itemName = '';
            this.error_csbForm_itemName = false;
            this.csbForm_consumables_code = '';
            // this.csbForm_quantity = ""
            this.csbForm_quantity = 0;
            this.error_csbForm_quantity = false;
            this.csbForm_total_expense = 0;
            this.csbForm_remaining_balance = 0;
            this.Maintenance_unit = null;
            this.error_csbForm_Maintenance_unit = false;
            this.csbForm_source_type = null;
            this.error_csbForm_source_type = false;
            this.csbForm_date_received = null;
            this.csbForm_date_expiration = null;
            this.csbForm_source_location = '';
            this.iev_organize = {};
            this.error_iev_organize = false;
            this.csbForm_storage_location = false;
            this.error_csbForm_storage_location = false;
            this.csbForm_date_create = '';
            this.csbForm_date_update = '';
            this.iie_selectedProvince = null;
            this.error_iie_selectedProvince = false;
            this.iie_selectedAmphur = null;
            this.error_iie_selectedAmphur = false;
            this.iie_selectedTambon = null;
            this.error_iie_selectedTambon = false;
            this.iie_lat = '';
            this.error_iie_lat = false;
            this.iie_lon = '';
            this.error_iie_lon = false;
            this.donatedItems_data = [];
            this.csb_cal = [];

            this.check_date_received = false;
            this.DataError_date_received = [];
            this.error_csbForm_date_received = false;

            this.error_csbForm_source_location = false;

            this.error_Over_quantity = false;

            this.clearSubData();
        },
        clearSubData() {
            this.dropdownClearFilerValue += 1;

            this.DI_date = null;
            this.error_DI_date = false;
            // this.DI_received = "";
            this.error_DI_received = false;
            this.DI_give = {};
            this.error_DI_give = false;
            // this.DI_count = "";
            this.DI_count = 0;
            this.error_DI_count = false;

            this.DI_total = '';
            this.DI_unit = '';
        },

        async clearSearchField() {
            this.csb_itemName = '';
            this.csb_sourceType_Selector = null;
            this.csb_source_location = '';
            this.csb_storage_location = {};
            this.csb_receivedDate = null;
            this.csb_expirationDate = null;
            this.organize_table = [];
            this.csb_consumables_code = '';

            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            this.text_Footer = false;

            this.dropdownClearFilerValue += 1;
            // Doe ค้นหา
            this.filter = '';
            this.cloneTable = [];
            this.initialData();
        },

        // Doe โหลด โทรศัพท์
        async MobileClearSearchField() {
            if (this.ms == true) {
                this.clearSearchField();
            } else {
                this.csb_itemName = '';
                this.csb_sourceType_Selector = null;
                this.csb_source_location = '';
                this.csb_storage_location = {};
                this.csb_receivedDate = null;
                this.csb_expirationDate = null;
                this.organize_table = [];
                this.csb_consumables_code = '';

                this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
                this.text_Footer = false;

                this.dropdownClearFilerValue += 1;
                this.filter = '';
                this.cloneTable = [];
            }
        },
        // Doe โหลด โทรศัพท์

        showImage(data) {
            if (data === null) {
                this.imgTable = null;
            } else if (data) {
                this.imgTable = [data];
            } else {
                this.imgTable = null;
            }

            this.displayBasic2 = true;
        },

        alertDisplay(temp, deleteAt) {
            this.$fire({
                title: 'ยืนยันการลบข้อมูล',
                text: 'คุณต้องการลบข้อมูลนี้ใช่หรือไม่ ?',

                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ตกลง',
                cancelButtonText: 'ยกเลิก'
            }).then((result) => {
                // console.log(temp)
                if (result.value) {
                    // console.log(temp)
                    this.confirmDelete(temp, deleteAt);
                }
            });
        },
        selectMap_passValue(variable) {
            // this.displayMap = false;
            this.iie_lat = variable.lat;
            this.iie_lon = variable.lng;
        },
        selectMap_displayMap() {
            this.displayMap = false;

            // แจ้งเตือนกรณีไม่ได้ ข้อมูลพิกัด
            // console.log("this.iie_lat",this.iie_lat)
            // console.log("this.iie_lon",this.iie_lon)
            if (this.iie_lat !== null && this.iie_lon !== null && this.iie_lat !== '' && this.iie_lon !== '') {
                this.$fire({
                    title: 'เพิ่มพิกัดสำเร็จ',
                    // text: "ข้อมูลพิกัด",
                    type: 'success',
                    timer: 3000,
                    confirmButtonColor: '#28B463'
                });
            } else {
                this.$fire({
                    title: 'ยังไม่ได้เลือกข้อมูลพิกัด',
                    // text: "ยังไม่ได้เลือกข้อมูลพิกัด",
                    type: 'warning',
                    timer: 3000,
                    confirmButtonColor: '#28B463'
                });
            }
        },

        someHandler(message) {
            if (message == 'ch-province') {
                this.iie_selectedAmphur = null;
            }
            if (message == 'ch-amphur') {
                this.iie_selectedTambon = null;
            }
        },

        //  Doe เพิ่มหมุด map V.2 6/9  -->
        async inputMap_latlon() {
            if (this.iie_lat !== '' && this.iie_lat !== null && this.iie_lon !== '' && this.iie_lon !== null) {
                await this.axios
                    .get(`https://api.deemap.com/service/geocode/lat=${this.iie_lat}/lon=${this.iie_lon}/key=0feb00d7e64c5686bf434b9b90ab2d3c`)
                    .then((response) => {
                        // debugger;
                        if (response.data.data.length > 0) {
                            const data = {
                                ADMIN_CODE: response.data.data[0].ADMIN_CODE,
                                provinceName: response.data.data[0].PROV_TNAME,
                                amphurName: response.data.data[0].AMP_TNAME,
                                tambonName: response.data.data[0].TAM_TNAME,
                                postCODE: response.data.data[0].POSTCOD
                            };
                            const element = data.ADMIN_CODE;
                            const country_ID = `${element[0]}${element[1]}`;
                            const land_ID = `${element[2]}${element[3]}`;
                            const province_ID = `${element[4]}${element[5]}`;
                            const amphur_ID = `${element[4]}${element[5]}${element[6]}${element[7]}`;
                            const tambon_ID = `${element[4]}${element[5]}${element[6]}${element[7]}${element[8]}${element[9]}`;

                            if (country_ID == '66' && land_ID !== '00') {
                                this.iie_selectedProvince = {
                                    province_name: data.provinceName,
                                    province_id: province_ID
                                };
                                this.iie_selectedAmphur = {
                                    amphur_name: data.amphurName,
                                    amphur_id: amphur_ID
                                };
                                this.iie_selectedTambon = {
                                    tambon_name: data.tambonName,
                                    tambon_id: tambon_ID
                                };

                                this.error_latlon_country = false;
                                this.error_latlon_land = false;

                                this.error_latlon_P = false;
                                this.error_latlon_A = false;
                                this.error_latlon_T = false;
                            } else {
                                if (country_ID !== '66') {
                                    this.error_latlon_country = true;
                                } else {
                                    this.error_latlon_country = false;
                                }
                                if (data.provinceName == null || data.provinceName == 'null' || data.provinceName == '' || data.provinceName == ' ') {
                                    this.error_latlon_P = true;
                                } else {
                                    this.error_latlon_P = false;
                                }
                                if (data.amphurName == null || data.amphurName == 'null' || data.amphurName == '' || data.amphurName == ' ') {
                                    this.error_latlon_A = true;
                                } else {
                                    this.error_latlon_A = false;
                                }
                                if (data.tambonName == null || data.tambonName == 'null' || data.tambonName == '' || data.tambonName == ' ') {
                                    this.error_latlon_T = true;
                                } else {
                                    this.error_latlon_T = false;
                                }
                                this.iie_selectedProvince = null;
                                this.iie_selectedAmphur = null;
                                this.iie_selectedTambon = null;
                            }

                            // console.log("this.iie_selectedProvince",this.iie_selectedProvince)
                            // console.log("this.iie_selectedAmphur",this.iie_selectedAmphur)
                            // console.log("this.iie_selectedTambon",this.iie_selectedTambon)
                        } else {
                            this.iie_selectedProvince = null;
                            this.iie_selectedAmphur = null;
                            this.iie_selectedTambon = null;

                            this.error_latlon_country = false;
                            this.error_latlon_land = false;

                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;
                        }
                    });
            } else {
                this.iie_selectedProvince = null;
                this.iie_selectedAmphur = null;
                this.iie_selectedTambon = null;

                this.error_latlon_country = false;
                this.error_latlon_land = false;

                this.error_latlon_P = false;
                this.error_latlon_A = false;
                this.error_latlon_T = false;
            }
        },

        async inputMap_PAT_latlon() {
            // console.log("<<<<<<<<<<<<<<<MMMMMMMMMMMMMM>>>>>>>>>>>>>>>")
            //   console.log("this.iie_selectedProvince",this.iie_selectedProvince)
            //   console.log("this.iie_selectedAmphur",this.iie_selectedAmphur)
            //   console.log("this.iie_selectedTambon",this.iie_selectedTambon)

            const url = 'https://service.deemap.com/service/gismis/boundary/geojson';

            let nnP = '';
            if (this.iie_selectedProvince) {
                this.sP.push(this.iie_selectedProvince.province_name);
                nnP = this.sP.length - 2;
            }

            let nnA = '';
            if (this.iie_selectedAmphur) {
                this.sA.push(this.iie_selectedAmphur.amphur_name);
                nnA = this.sA.length - 2;
            }

            if (this.iie_selectedProvince == null) {
                this.iie_lat = '';
                this.iie_lon = '';

                this.error_latlon_country = false;
                this.error_latlon_P = false;
                this.error_latlon_A = false;
                this.error_latlon_T = false;
            } else if (this.iie_selectedAmphur == null) {
                await this.axios
                    .post(url, {
                        key: '78e731027d8fd50ed642340b7c9a63b3',
                        topic: 'province',
                        type: 'point',
                        id: this.iie_selectedProvince.province_id
                    })
                    .then((response) => {
                        let getData = response.data.data;

                        const lon = getData.features[0].geometry.coordinates[0];
                        const lat = getData.features[0].geometry.coordinates[1];

                        this.iie_lat = lat;
                        this.iie_lon = lon;

                        this.error_latlon_country = false;
                        this.error_latlon_P = false;
                        this.error_latlon_A = false;
                        this.error_latlon_T = false;
                    });
            } else if (this.sP[nnP] !== this.iie_selectedProvince.province_name) {
                await this.axios
                    .post(url, {
                        key: '78e731027d8fd50ed642340b7c9a63b3',
                        topic: 'province',
                        type: 'point',
                        id: this.iie_selectedProvince.province_id
                    })
                    .then((response) => {
                        let getData = response.data.data;

                        const lon = getData.features[0].geometry.coordinates[0];
                        const lat = getData.features[0].geometry.coordinates[1];

                        this.iie_lat = lat;
                        this.iie_lon = lon;

                        this.error_latlon_country = false;
                        this.error_latlon_P = false;
                        this.error_latlon_A = false;
                        this.error_latlon_T = false;
                    });
            } else if (this.sA[nnA] !== this.iie_selectedAmphur.amphur_name) {
                await this.axios
                    .post(url, {
                        key: '78e731027d8fd50ed642340b7c9a63b3',
                        topic: 'amphoe',
                        type: 'point',
                        id: this.iie_selectedAmphur.amphur_id
                    })
                    .then((response) => {
                        let getData = response.data.data;

                        const lon = getData.features[0].geometry.coordinates[0];
                        const lat = getData.features[0].geometry.coordinates[1];

                        this.iie_lat = lat;
                        this.iie_lon = lon;

                        this.error_latlon_country = false;
                        this.error_latlon_P = false;
                        this.error_latlon_A = false;
                        this.error_latlon_T = false;
                    });
            } else {
                if (this.iie_selectedTambon) {
                    await this.axios
                        .post(url, {
                            key: '78e731027d8fd50ed642340b7c9a63b3',
                            topic: 'tambon',
                            type: 'point',
                            id: this.iie_selectedTambon.tambon_id
                        })
                        .then((response) => {
                            let getData = response.data.data;

                            const lon = getData.features[0].geometry.coordinates[0];
                            const lat = getData.features[0].geometry.coordinates[1];

                            this.iie_lat = lat;
                            this.iie_lon = lon;

                            this.error_latlon_country = false;
                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;
                        });
                } else if (this.iie_selectedAmphur) {
                    await this.axios
                        .post(url, {
                            key: '78e731027d8fd50ed642340b7c9a63b3',
                            topic: 'amphoe',
                            type: 'point',
                            id: this.iie_selectedAmphur.amphur_id
                        })
                        .then((response) => {
                            let getData = response.data.data;

                            const lon = getData.features[0].geometry.coordinates[0];
                            const lat = getData.features[0].geometry.coordinates[1];

                            this.iie_lat = lat;
                            this.iie_lon = lon;

                            this.error_latlon_country = false;
                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;
                        });
                } else if (this.iie_selectedProvince) {
                    await this.axios
                        .post(url, {
                            key: '78e731027d8fd50ed642340b7c9a63b3',
                            topic: 'province',
                            type: 'point',
                            id: this.iie_selectedProvince.province_id
                        })
                        .then((response) => {
                            let getData = response.data.data;

                            const lon = getData.features[0].geometry.coordinates[0];
                            const lat = getData.features[0].geometry.coordinates[1];

                            this.iie_lat = lat;
                            this.iie_lon = lon;

                            this.error_latlon_country = false;
                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;
                        });
                } else {
                    this.iie_lat = '';
                    this.iie_lon = '';
                }
            }
        },
        //  Doe เพิ่มหมุด map V.2 6/9  จบ-->

        // Doe :   เพิ่ม มุดmap 4/4
        sendM(iie_lat, iie_lon) {
            let lat = iie_lat;
            let lon = iie_lon;
            this.latlon = { lat, lon };
            // console.log("send ",this.latlon)
        },
        sendM_PAT(tambon, amphur, province) {
            if (tambon) {
                this.PAT = tambon;
                // console.log("this.PAT=tambon",this.PAT)
            } else if (amphur) {
                this.PAT = amphur;
                // console.log("amphur",amphur)
            } else if (province) {
                this.PAT = province;
                // console.log("province",province)
            } else {
                this.PAT = {};
                // console.log("this.PAT={}",this.PAT)
            }
        },
        //  Doe เพิ่มหมุด map V.2 8/9  -->
        receiveM_PAT(data) {
            // console.log("data",data)
            const element = data.ADMIN_CODE;
            const country_ID = `${element[0]}${element[1]}`;
            const land_ID = `${element[2]}${element[3]}`;
            const province_ID = `${element[4]}${element[5]}`;
            const amphur_ID = `${element[4]}${element[5]}${element[6]}${element[7]}`;
            const tambon_ID = `${element[4]}${element[5]}${element[6]}${element[7]}${element[8]}${element[9]}`;

            if (country_ID == '66' && land_ID !== '00') {
                this.iie_selectedProvince = {
                    province_name: data.provinceName,
                    province_id: province_ID
                };
                this.iie_selectedAmphur = {
                    amphur_name: data.amphurName,
                    amphur_id: amphur_ID
                };
                this.iie_selectedTambon = {
                    tambon_name: data.tambonName,
                    tambon_id: tambon_ID
                };

                this.error_latlon_country = false;
                this.error_latlon_land = false;

                this.error_latlon_P = false;
                this.error_latlon_A = false;
                this.error_latlon_T = false;
            } else {
                if (country_ID !== '66') {
                    this.error_latlon_country = true;
                } else {
                    this.error_latlon_country = false;
                }

                if (data.provinceName == null || data.provinceName == 'null' || data.provinceName == '' || data.provinceName == ' ') {
                    this.error_latlon_P = true;
                } else {
                    this.error_latlon_P = false;
                }
                if (data.amphurName == null || data.amphurName == 'null' || data.amphurName == '' || data.amphurName == ' ') {
                    this.error_latlon_A = true;
                } else {
                    this.error_latlon_A = false;
                }
                if (data.tambonName == null || data.tambonName == 'null' || data.tambonName == '' || data.tambonName == ' ') {
                    this.error_latlon_T = true;
                } else {
                    this.error_latlon_T = false;
                }

                this.iie_selectedProvince = null;
                this.iie_selectedAmphur = null;
                this.iie_selectedTambon = null;
            }
        },
        //  Doe เพิ่มหมุด map V.2 8/9  จบ-->
        // Doe :   เพิ่ม มุดmap 4/4 จบ

        // Doe PDF เลือกได้  5/5
        EditPDF() {
            this.displayEditPDF = true;
            this.columnsSelectorDialog = this.columnsSelector;
        },
        SaveEditPDF() {
            if (this.columnsSelectorDialog.length <= 4) {
                this.PDF_minCellWidthVer = 120;
                this.PDF_FontHeaderVer = 15;
                this.PDF_FontBodyVer = 12;

                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 35 }
                };

                this.PDF_minCellWidthHor = 130;
                this.PDF_FontHeaderHor = 15;
                this.PDF_FontBodyHor = 12;

                this.PDF_BodySizeHorSelect = {
                    index: { cellWidth: 35 }
                };
            } else if (this.columnsSelectorDialog.length <= 6) {
                this.PDF_minCellWidthVer = 90;
                this.PDF_FontHeaderVer = 15;
                this.PDF_FontBodyVer = 12;

                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 35 },
                    date_update_consumables: { cellWidth: 75 },
                    consumables_code: { cellWidth: 60 }
                };

                this.PDF_minCellWidthHor = 130;
                this.PDF_FontHeaderHor = 15;
                this.PDF_FontBodyHor = 12;

                this.PDF_BodySizeHorSelect = {
                    index: { cellWidth: 35 }
                };
            } else if (this.columnsSelectorDialog.length <= 10) {
                this.PDF_minCellWidthVer = 50;
                this.PDF_FontHeaderVer = 9;
                this.PDF_FontBodyVer = 7;
                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 30 },

                    date_update_consumables: { cellWidth: 50 },
                    consumables_code: { cellWidth: 40 }
                };

                this.PDF_minCellWidthHor = 80;
                this.PDF_FontHeaderHor = 13;
                this.PDF_FontBodyHor = 11;

                this.PDF_BodySizeHorSelect = {
                    index: { cellWidth: 30 },

                    date_update_consumables: { cellWidth: 70 },
                    consumables_code: { cellWidth: 55 }
                };
            } else if (this.columnsSelectorDialog.length <= 13) {
                this.PDF_minCellWidthVer = 40;
                this.PDF_FontHeaderVer = 7.5;
                this.PDF_FontBodyVer = 5.5;
                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 21.5 },

                    quantity: { cellWidth: 25 },
                    total_expense: { cellWidth: 27 },
                    remaining_balance: { cellWidth: 35 },
                    unit: { cellWidth: 25 },

                    source_type: { cellWidth: 36 },

                    consumables_code: { cellWidth: 35 },
                    date_create_consumables: { cellWidth: 42 },
                    date_update_consumables: { cellWidth: 38 }
                };

                this.PDF_minCellWidthHor = 50;
                this.PDF_FontHeaderHor = 10;
                this.PDF_FontBodyHor = 8;

                this.PDF_BodySizeHorSelect = {
                    index: { cellWidth: 32 },

                    quantity: { cellWidth: 40 },
                    total_expense: { cellWidth: 40 },
                    remaining_balance: { cellWidth: 50 },
                    unit: { cellWidth: 38 },

                    source_type: { cellWidth: 55 },

                    consumables_code: { cellWidth: 43 },
                    organize_name: { cellWidth: 70 },
                    date_create_consumables: { cellWidth: 60 },
                    date_update_consumables: { cellWidth: 63 }
                };
            } else if (this.columnsSelectorDialog.length <= 17) {
                this.PDF_minCellWidthVer = 40;
                this.PDF_FontHeaderVer = 7.5;
                this.PDF_FontBodyVer = 5.5;
                this.PDF_BodySizeSelect = this.PDF_BodySize;

                this.PDF_minCellWidthHor = 50;
                this.PDF_FontHeaderHor = 10;
                this.PDF_FontBodyHor = 8;

                this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor;
            }

            this.columnsSelector = this.columnsSelectorDialog;

            if (this.columnsSelectorDialog.length == 0) {
                this.columns_index = false;
                this.columns_img = false;
                this.columns_date_received = false;
                this.columns_item_name = false;
                this.columns_quantity = false;
                this.columns_total_expense = false;
                this.columns_remaining_balance = false;
                this.columns_unit = false;
                this.columns_date_expiration = false;
                this.columns_storage_location = false;
                this.columns_lat = false;

                this.columns_lon = false;

                this.columns_source_type = false;
                this.columns_source_location = false;
                this.columns_consumables_code = false;
                this.columns_organize_name = false;
                this.columns_date_create_consumables = false;
                this.columns_date_update_consumables = false;

                this.columns_editor = false;

                this.columns_disabled = false;
            } else if (this.columnsSelectorDialog.length == 17) {
                this.columns_index = true;
                this.columns_img = true;
                this.columns_date_received = true;
                this.columns_item_name = true;
                this.columns_quantity = true;

                this.columns_total_expense = true;
                this.columns_remaining_balance = true;
                this.columns_unit = true;
                this.columns_date_expiration = true;
                this.columns_storage_location = true;
                this.columns_lat = true;
                this.columns_lon = true;

                this.columns_source_type = true;
                this.columns_source_location = true;
                this.columns_consumables_code = true;
                this.columns_organize_name = true;
                this.columns_date_create_consumables = true;
                this.columns_date_update_consumables = true;

                this.columns_editor = true;

                this.columns_disabled = true;
            } else {
                this.columns_disabled = true;
                // console.log('this.columnsSelectorDialog =', this.columnsSelectorDialog);

                this.GetData_ColumnsSearch = [];
                // ! จัดข้อมูล
                for (let index = 0; index < this.columnsSelector.length; index++) {
                    this.GetData_ColumnsSearch.push(this.columnsSelector[index].dataKey);
                }
                let getData = this.GetData_ColumnsSearch;
                // console.log("getData",getData);

                // ! เช็คข้อมูล

                for (let index = 0; index < this.columnsSelector.length; index++) {
                    const element = this.columnsSelector[index].dataKey;

                    if (element == 'index') {
                        this.columns_index = true;
                    } else if (!getData.includes('index')) {
                        this.columns_index = false;
                    }

                    if (element == 'image') {
                        this.columns_img = true;
                    } else if (!getData.includes('image')) {
                        this.columns_img = false;
                    }

                    if (element == 'date_received') {
                        this.columns_date_received = true;
                    } else if (!getData.includes('date_received')) {
                        this.columns_date_received = false;
                    }

                    if (element == 'item_name') {
                        this.columns_item_name = true;
                    } else if (!getData.includes('item_name')) {
                        this.columns_item_name = false;
                    }

                    if (element == 'quantity') {
                        this.columns_quantity = true;
                    } else if (!getData.includes('quantity')) {
                        this.columns_quantity = false;
                    }

                    if (element == 'total_expense') {
                        this.columns_total_expense = true;
                    } else if (!getData.includes('total_expense')) {
                        this.columns_total_expense = false;
                    }

                    if (element == 'remaining_balance') {
                        this.columns_remaining_balance = true;
                    } else if (!getData.includes('remaining_balance')) {
                        this.columns_remaining_balance = false;
                    }

                    if (element == 'unit') {
                        this.columns_unit = true;
                    } else if (!getData.includes('unit')) {
                        this.columns_unit = false;
                    }

                    if (element == 'date_expiration') {
                        this.columns_date_expiration = true;
                    } else if (!getData.includes('date_expiration')) {
                        this.columns_date_expiration = false;
                    }

                    if (element == 'storage_location') {
                        this.columns_storage_location = true;
                    } else if (!getData.includes('storage_location')) {
                        this.columns_storage_location = false;
                    }

                    if (element == 'organize_lat') {
                        this.columns_lat = true;
                    } else if (!getData.includes('organize_lat')) {
                        this.columns_lat = false;
                    }

                    if (element == 'organize_lon') {
                        this.columns_lon = true;
                    } else if (!getData.includes('organize_lon')) {
                        this.columns_lon = false;
                    }

                    if (element == 'source_type') {
                        this.columns_source_type = true;
                    } else if (!getData.includes('source_type')) {
                        this.columns_source_type = false;
                    }

                    if (element == 'source_location') {
                        this.columns_source_location = true;
                    } else if (!getData.includes('source_location')) {
                        this.columns_source_location = false;
                    }

                    if (element == 'consumables_code') {
                        this.columns_consumables_code = true;
                    } else if (!getData.includes('consumables_code')) {
                        this.columns_consumables_code = false;
                    }

                    if (element == 'organize_name') {
                        this.columns_organize_name = true;
                    } else if (!getData.includes('organize_name')) {
                        this.columns_organize_name = false;
                    }

                    if (element == 'date_create_consumables') {
                        this.columns_date_create_consumables = true;
                    } else if (!getData.includes('date_create_consumables')) {
                        this.columns_date_create_consumables = false;
                    }

                    if (element == 'date_update_consumables') {
                        this.columns_date_update_consumables = true;
                    } else if (!getData.includes('date_update_consumables')) {
                        this.columns_date_update_consumables = false;
                    }

                    if (element == 'user_fullname') {
                        this.columns_editor = true;
                    } else if (!getData.includes('user_fullname')) {
                        this.columns_editor = false;
                    }
                }
            }

            this.displayEditPDF = false;
            this.filter = '';
        },
        CloseEditPDF() {
            this.displayEditPDF = false;
        },
        ClearEditPDF() {
            this.columnsSelectorDialog = [];
        },
        SelectAllEditPDF() {
            this.columnsSelectorDialog = this.columns;
        }
        // Doe PDF เลือกได้  5/5 จบ
    }
};
</script>
<style scoped>
@media screen and (max-width: 991px) {
    #text_Footer {
        font-size: 1rem;
    }
}

/*   Doe เพิ่มหมุด map V.2 9/9  --> */
.warningLATLON {
    color: rgb(225, 144, 13);
    font-size: 0.9rem;
}
/*   Doe เพิ่มหมุด map V.2 9/9  จบ--> */

@media screen and (max-width: 991px) {
    .DI_Modal {
        display: block !important;
    }
    .DI_Modal_errorText {
        text-align: center;
        margin-bottom: 1rem;
    }
}
.DI_Modal {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.DI_Modal_errorText {
    color: red;
}
.table_statusColor {
    color: #090073;
    display: inline-flex;
    padding: 5px 15px 5px 15px;
    font-weight: bolder;
    border-radius: 10px;
}
.table_row {
    text-align: center;
}

.imgDia {
    width: 100%;
    display: block;
}

@media screen and (min-width: 819px) and (max-width: 1200px) {
    #Search {
        width: 20rem;
    }
}
/* @media screen and (min-width: 538px){
      #Create{
      width: 146px;
    }
   
} */
#text_Foote {
    font-size: 1.2rem;
}
#Create {
    width: 149px;
}
#EX {
    width: 149px;
}
#PDF {
    width: 149px;
}
#TABLE_EDIT {
    width: 149px;
}
@media screen and (max-width: 818px) {
    #Search {
        width: 100%;
    }
}
.EquipV {
    width: 300px;
    white-space: normal;
}
@media screen and (max-width: 430px) {
    #Create {
        width: 50%;
    }
    #EX {
        width: 50%;
    }
    #PDF {
        width: 55%;
    }
    #TABLE_EDIT {
        width: 45%;
    }
    .EV_disasterOptions {
        width: 16.75rem;
        overflow-y: scroll;
    }
    .EV_disasterOptions::-webkit-scrollbar {
        width: 0;
        height: 1px;
    }

    .EV_disasterOptions::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    }

    .EV_disasterOptions::-webkit-scrollbar-thumb {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
    }
    .EquipV {
        width: 20rem;
        overflow-y: scroll;
    }
    .EquipV::-webkit-scrollbar {
        width: 0;
        height: 1px;
    }

    .EquipV::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    }

    .EquipV::-webkit-scrollbar-thumb {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
    }
}

.p-field {
    margin-bottom: 0rem;
}
#preview {
    display: flex;
    justify-content: center;
    align-items: center;
}

#preview img {
    width: 234px;
    border: solid 1px #cccccc;
}

.img-content {
    text-align: center;
}
</style>

<style>
.vue-json-excel__thead-cell {
    font-weight: normal !important;
}
/* โหลดเพิ่มแก้ไข 8/8*/

.From_Loading {
    position: absolute;
    top: 35vh;
    left: 42.5%;

    z-index: 1000;
}
@media screen and (max-width: 430px) {
    .From_Loading {
        position: absolute;
        top: 35vh;
        left: 30%;

        z-index: 1000;
    }
}
@keyframes p-progress-spinner-color {
    100%,
    0% {
        stroke: #75e9f4;
    }
    40% {
        stroke: #0057e7;
    }
    66% {
        stroke: #75e9f4;
    }
    80%,
    90% {
        stroke: #0057e7;
    }
}
.waveTextAnimated {
    margin-top: 0.6em;
    font-weight: bolder;
    margin-top: 0.5rem;
    font-size: 1.2rem;
    text-shadow: 1px 2px #78777794;
    text-align: center;
}
.waveTextAnimated span {
    display: inline-block;
    -webkit-animation: wave-text 1s ease-in-out infinite;
    animation: wave-text 1s ease-in-out infinite;
}
.waveTextAnimated span:nth-of-type(1) {
    -webkit-animation-delay: 0s;
    animation-delay: 0s;
}
.waveTextAnimated span:nth-of-type(2) {
    -webkit-animation-delay: 0.1s;
    animation-delay: 0.1s;
}
.waveTextAnimated span:nth-of-type(3) {
    -webkit-animation-delay: 0.2s;
    animation-delay: 0.2s;
}
.waveTextAnimated span:nth-of-type(4) {
    -webkit-animation-delay: 0.3s;
    animation-delay: 0.3s;
}
.waveTextAnimated span:nth-of-type(5) {
    -webkit-animation-delay: 0.4s;
    animation-delay: 0.4s;
}
.waveTextAnimated span:nth-of-type(6) {
    -webkit-animation-delay: 0.5s;
    animation-delay: 0.5s;
}
@-webkit-keyframes wave-text {
    00% {
        transform: translateY(0em);
    }
    60% {
        transform: translateY(-0.3em);
    }
    100% {
        transform: translateY(0em);
    }
}

@keyframes wave-text {
    00% {
        transform: translateY(0em);
    }
    60% {
        transform: translateY(-0.3em);
    }
    100% {
        transform: translateY(0em);
    }
}
/* โหลดเพิ่มแก้ไข ข้อมูล 8/8 จบ*/

.p-datatable-thead {
    border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
    border: 2px solid #d6d6d6;
}
</style>

<style scoped lang="scss">
:deep(.p-datatable-wrapper table) {
    border-left: 1px solid #d6d4d4;
    border-right: 1px solid #d6d4d4;
    border-collapse: separate;
    border-spacing: 0;
}
:deep(.p-datatable-scrollable-header-table) {
    background-color: #d6d4d4;
}
:deep(.p-datatable-wrapper) {
    max-height: 550px;
    overflow: auto;
}

.p-multiselect {
    min-width: 15rem;
}

.multiselect-custom {
    // Doe PDF เลือกได้
    width: 100%;
    .p-multiselect-label:not(.p-placeholder) {
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
    }

    .item {
        display: flex;
        align-items: center;
    }

    .item-value {
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 3px;
        display: inline-flex;
        margin-right: 0.5rem;
        background-color: var(--primary-color);
        color: var(--primary-color-text);
    }
}
</style>
